import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { collection, doc, addDoc, getDocs, query, orderBy, limit, serverTimestamp, getDoc, onSnapshot, updateDoc, increment, where } from 'firebase/firestore'; 
import { db } from '../firebase';
import { matchesSearch } from '../utils/searchText';
import { allocateIslemNo } from '../utils/islemNoService';
import { v4 as uuidv4 } from 'uuid';
import { usePriceContext } from '../context/PriceContext';

// --- MUI Kütüphaneleri ---
import { 
  Box, Grid, Paper, Typography, TextField, Button, Select, MenuItem, 
  FormControl, InputLabel, Switch, FormControlLabel, InputAdornment, 
  Divider, IconButton, Card, CardContent, Alert, Dialog, DialogContent
} from '@mui/material';
import { 
  Save as SaveIcon, 
  Print as PrintIcon, 
  AddCircle as AddIcon, 
  Delete as DeleteIcon, 
  Person as PersonIcon, 
  Business as BusinessIcon, 
  ReceiptLong as ReceiptIcon,
  Calculate as CalculateIcon,
  PointOfSale as PosIcon,
  Add as AddPlusIcon
} from '@mui/icons-material';
import QuickCustomerAddModal from '../components/QuickCustomerAddModal';
import QuickCompanyAddModal from '../components/QuickCompanyAddModal';
import { findMusteriByTypedName } from '../utils/islemMusteriMatch';
import { attachFinanceSnapshotToIslem, loadFinanceCostContext } from '../utils/finance/attachFinanceSnapshot';

// --- GÜMÜŞ REFERANS LİSTESİ ---
const gumusReferanslari = [
  { gr: 5, ad: '5 Gram Paketli Granül Gümüş' },
  { gr: 10, ad: '10 Gram Paketli Granül Gümüş' },
  { gr: 20, ad: '20 Gram Paketli Granül Gümüş' },
  { gr: 30, ad: '30 Gram Paketli Granül Gümüş' },
  { gr: 40, ad: '40 Gram Paketli Granül Gümüş' },
  { gr: 50, ad: '50 Gram Paketli Granül Gümüş' },
  { gr: 100, ad: '100 Gram Paketli Granül Gümüş' },
  { gr: 200, ad: '200 Gram Paketli Granül Gümüş' },
  { gr: 300, ad: '300 Gram Paketli Granül Gümüş' },
  { gr: 400, ad: '400 Gram Paketli Granül Gümüş' },
  { gr: 500, ad: '500 Gram Paketli Granül Gümüş' },
  { gr: 1000, ad: '1 Kilogram Külçe Gümüş' } 
];

function YeniIslem() {
  const location = useLocation();
  const navigate = useNavigate();
  const { prices } = usePriceContext();
  const queryParams = new URLSearchParams(location.search);
  const sube = queryParams.get('sube')?.trim();
  
  // --- FYM STATE'LERİ ---
  const [formuller, setFormuller] = useState([]);
  const [genelAyarlar, setGenelAyarlar] = useState({ 
    aktif: false,
    manuelHasAlis: 0, manuelHasSatis: 0,
    manuelOnsAlis: 0, manuelOnsSatis: 0,
    manuelGumUsOnsAlis: 0, manuelGumUsOnsSatis: 0,
    manuelDolarAlis: 0, manuelDolarSatis: 0,
    manuelEuroAlis: 0, manuelEuroSatis: 0,
    manuelPariteAlis: 0, manuelPariteSatis: 0
  });

  const [isMultiMode, setIsMultiMode] = useState(false);
  const [multiItems, setMultiItems] = useState([
    {
      kategori: '',
      urun: '',
      islemTuru: '',
      gram: '',
      adet: '',
      hasFiyati: '',
      urunBilgisi: '',
      barkod: '',
      islemAciklamasi: '',
      bakiye: '',
      nakit: '',
      havaleEft: '',
      krediKarti: '',
      listeFiyati: '',
      hasEsdeger: '',
      teslimatDurumu: false, 
      planlananTeslimTarihi: '' 
    },
  ]);

  const [kategori, setKategori] = useState('');
  const [urun, setUrun] = useState('');
  const [islemTuru, setIslemTuru] = useState('');
  
  const [musteriInput, setMusteriInput] = useState('');
  const [selectedMusteri, setSelectedMusteri] = useState(null);
  
  const [firmaInput, setFirmaInput] = useState('');
  const [selectedFirma, setSelectedFirma] = useState(null);
  
  const [barkod, setBarkod] = useState('');
  const [gram, setGram] = useState('');
  const [adet, setAdet] = useState('');
  const [urunBilgisi, setUrunBilgisi] = useState('');
  const [islemAciklamasi, setIslemAciklamasi] = useState('');
  
  const [hasFiyati, setHasFiyati] = useState('');
  const [bakiye, setBakiye] = useState('');
  const [hasEsdeger, setHasEsdeger] = useState('');
  
  const [nakit, setNakit] = useState('');
  const [havaleEft, setHavaleEft] = useState('');
  const [krediKarti, setKrediKarti] = useState('');
  const [listeFiyati, setListeFiyati] = useState('');

  const [teslimatDurumu, setTeslimatDurumu] = useState(false); 
  const [planlananTeslimTarihi, setPlanlananTeslimTarihi] = useState(''); 
  
  const [islemFisi, setIslemFisi] = useState(''); 
  
  const [hata, setHata] = useState('');
  /** Kayıt sonrası kısa süreli onay penceresi (2 sn) */
  const [kayitBasariDialogAcik, setKayitBasariDialogAcik] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [musteriListesi, setMusteriListesi] = useState([]);
  const [firmaListesi, setFirmaListesi] = useState([]);
  const [filteredMusteri, setFilteredMusteri] = useState([]);
  const [filteredFirma, setFilteredFirma] = useState([]);
  const [showMusteriDropdown, setShowMusteriDropdown] = useState(false);
  const [showFirmaDropdown, setShowFirmaDropdown] = useState(false);
  const [quickCustomerModalOpen, setQuickCustomerModalOpen] = useState(false);
  const [quickCompanyModalOpen, setQuickCompanyModalOpen] = useState(false);
  
  const [urunListesi, setUrunListesi] = useState([]);
  const [filteredUrunler, setFilteredUrunler] = useState([]);
  const [showBarkodDropdown, setShowBarkodDropdown] = useState(false);
  const barkodSecildiRef = useRef(false);

  const isFirmaSelected = !!selectedFirma || (firmaInput && firmaInput.trim().length > 0);

  const handleQuickCustomerAdded = (newMusteri) => {
    setMusteriListesi((prev) => {
      const exists = prev.some((m) => m.id === newMusteri.id);
      if (exists) return prev;
      return [...prev, newMusteri];
    });
    setMusteriInput(newMusteri.ad);
    setSelectedMusteri({ id: newMusteri.id, isim: newMusteri.isim, soyisim: newMusteri.soyisim });
    setSelectedFirma(null);
    setFirmaInput('');
    setShowMusteriDropdown(false);
    setQuickCustomerModalOpen(false);
    if (errors.musteri) {
      setErrors((prev) => ({ ...prev, musteri: undefined }));
    }
  };

  const handleQuickCompanyAdded = (newFirma) => {
    setFirmaListesi((prev) => {
      const exists = prev.some((f) => f.id === newFirma.id);
      if (exists) return prev;
      return [...prev, newFirma];
    });
    setFirmaInput(newFirma.ad);
    setSelectedFirma({ id: newFirma.id, firmaIsmi: newFirma.firmaIsmi });
    setSelectedMusteri(null);
    setMusteriInput('');
    setShowFirmaDropdown(false);
    setQuickCompanyModalOpen(false);
    if (errors.musteri) {
      setErrors((prev) => ({ ...prev, musteri: undefined }));
    }
  };

  const kategoriler = [
    'Sarrafiye', 'Gram Altın', 'Takı Ürün', 'Hurda', 'Döviz', 'Genel'
  ];

  const urunler = {
    Sarrafiye: [
      'Eski Ziynet Çeyrek', 'Yeni Ziynet Çeyrek', 'Eski Ziynet Yarım', 'Yeni Ziynet Yarım',
      'Eski Ziynet Tam', 'Yeni Ziynet Tam', "Eski Ziynet 2.5'lu Gremse", "Yeni Ziynet 2.5'lu Gremse",
      'Eski Ziynet Beşli', 'Yeni Ziynet Beşli', 'Cumhuriyet Ata Çeyrek', 'Cumhuriyet Ata Yarım',
      'Cumhuriyet Ata', "Cumhuriyet Ata 2.5'lu", 'Cumhuriyet Ata Beşli', 'Reşat',
      "Reşat 2.5'lu", 'Reşat Beşli'
    ],
    'Gram Altın': [
      '1 Gram 22 Ayar', '0.50 Gram 22 Ayar', '0.25 Gram 22 Ayar', '1 Gram 24 Ayar',
      '0.50 Gram 24 Ayar', '0.25 Gram 24 Ayar', '2.50 Gram 24 Ayar', '5 Gram 24 Ayar',
      '10 Gram 24 Ayar', '20 Gram 24 Ayar', '50 Gram 24 Ayar', '100 Gram 24 Ayar'
    ],
    'Takı Ürün': [
      '22 Ayar Bilezik', '14 Ayar Bilezik', '8 Ayar Bilezik', '22 Ayar Takı',
      '21 Ayar Takı', '18 Ayar Takı', '14 Ayar Takı', '8 Ayar Takı'
    ],
    Hurda: [
      '24 Ayar Hurda', '22 Ayar Bilezik Hurda', '22 Ayar Hurda', '21 Ayar Hurda',
      '18 Ayar Hurda', '14 Ayar Hurda', '8 Ayar Hurda'
    ],
    Döviz: [
      'TL - Türk Lirası', 'USD - Amerikan Doları', 'EUR - Euro', 'GBP - İngiliz Sterlini',
      'CHF - İsviçre Frangı', 'AUD - Avustralya Doları', 'CAD - Kanada Doları',
      'SAR - Suudi Arabistan Riyali', 'AED - Birleşik Arap Emirlikleri Dirhemi',
      'QAR - Katar Riyali', 'MAD - Fas Dirhemi', 'JOD - Ürdün Dinarı',
      'KWD - Kuveyt Dinarı', 'CNY - Çin Yuanı', 'RUB - Rus Rublesi', 'BGN - Bulgar Levası'
    ],
    Genel: ['Gümüş']
  };

  const islemTurleri = ['Alış', 'Satış', 'Giriş', 'Çıkış', 'İade', 'Değişim'];

  const getItem = (data, code) => {
    if (!data || !Array.isArray(data)) {
      return { currencyCode: code, sell: 0, buy: 0 };
    }
    const item = data.find((item) => item && item.currencyCode && item.currencyCode.toUpperCase() === code.toUpperCase());
    return item || { currencyCode: code, sell: 0, buy: 0 };
  };

  const updateStock = async (urunBarkod, miktar) => {
      if (!urunBarkod) return;
      try {
          const urunlerRef = collection(db, 'subeler', sube, 'urunler');
          const q = query(urunlerRef, where("barkod", "==", urunBarkod));
          const snapshot = await getDocs(q);
          if (!snapshot.empty) {
              const urunDoc = snapshot.docs[0];
              const urunRef = doc(db, 'subeler', sube, 'urunler', urunDoc.id);
              await updateDoc(urunRef, {
                  stok: increment(-miktar)
              });
          }
      } catch (err) {
          console.error("Stok düşme hatası:", err);
      }
  };

  useEffect(() => {
    const unsubFormul = onSnapshot(collection(db, "formuller"), (snapshot) => {
      const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFormuller(list);
    });

    const unsubAyarlar = onSnapshot(doc(db, "ayarlar", "genel_durum"), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setGenelAyarlar({
            aktif: data.aktif,
            manuelHasAlis: parseFloat(data.manuelHasAlis || 0), manuelHasSatis: parseFloat(data.manuelHasSatis || 0),
            manuelOnsAlis: parseFloat(data.manuelOnsAlis || 0), manuelOnsSatis: parseFloat(data.manuelOnsSatis || 0),
            manuelGumUsOnsAlis: parseFloat(data.manuelGumUsOnsAlis || 0), manuelGumUsOnsSatis: parseFloat(data.manuelGumUsOnsSatis || 0),
            manuelDolarAlis: parseFloat(data.manuelDolarAlis || 0), manuelDolarSatis: parseFloat(data.manuelDolarSatis || 0),
            manuelEuroAlis: parseFloat(data.manuelEuroAlis || 0), manuelEuroSatis: parseFloat(data.manuelEuroSatis || 0),
            manuelPariteAlis: parseFloat(data.manuelPariteAlis || 0), manuelPariteSatis: parseFloat(data.manuelPariteSatis || 0)
        });
      }
    });

    return () => {
        unsubFormul();
        unsubAyarlar();
    };
  }, []);

  const calculateNormal = (formul) => {
    if (formul.isManual) return { alis: Number(formul.manualBuy), satis: Number(formul.manualSell) };
    const sourceData = getItem(prices, formul.kaynak);
    const baseAlis = parseFloat(sourceData?.buy) || 0;
    const baseSatis = parseFloat(sourceData?.sell) || 0;
    const hAlis = (baseAlis * parseFloat(formul.alisCarpan)) + parseFloat(formul.alisIscilik);
    const hSatis = (baseSatis * parseFloat(formul.satisCarpan)) + parseFloat(formul.satisIscilik);
    return { alis: hAlis, satis: hSatis };
  };

  const calculateAcil = (formul) => {
    let baseAlis = 0; let baseSatis = 0; 
    
    const effectiveSource = formul.acilKaynak || 'MANUEL_HAS';
    
    if (effectiveSource === "OTO_EURKG_PARITE") {
        const pariteAlis = genelAyarlar.manuelPariteAlis || 1; const pariteSatis = genelAyarlar.manuelPariteSatis || 1;
        baseAlis = pariteAlis > 0 ? (genelAyarlar.manuelOnsAlis * 32.15) / pariteAlis : 0;
        baseSatis = pariteSatis > 0 ? (genelAyarlar.manuelOnsSatis * 32.15) / pariteSatis : 0;
    } 
    else if (effectiveSource === "OTO_GOLD_SILVER_RATIO") {
        baseAlis = genelAyarlar.manuelGumUsOnsAlis > 0 ? genelAyarlar.manuelOnsAlis / genelAyarlar.manuelGumUsOnsAlis : 0;
        baseSatis = genelAyarlar.manuelGumUsOnsSatis > 0 ? genelAyarlar.manuelOnsSatis / genelAyarlar.manuelGumUsOnsSatis : 0;
    }
    else if (effectiveSource === "OTO_GUMUS_TL") {
        baseAlis = (genelAyarlar.manuelGumUsOnsAlis * genelAyarlar.manuelDolarAlis) / 31.1035;
        baseSatis = (genelAyarlar.manuelGumUsOnsSatis * genelAyarlar.manuelDolarSatis) / 31.1035;
    }
    else if (effectiveSource === "MANUEL_GUMUS_ONS") {
        baseAlis = genelAyarlar.manuelGumUsOnsAlis; baseSatis = genelAyarlar.manuelGumUsOnsSatis;
    }
    else if (effectiveSource === "MANUEL_ONS") {
        baseAlis = genelAyarlar.manuelOnsAlis; baseSatis = genelAyarlar.manuelOnsSatis;
    } else if (effectiveSource === "MANUEL_DOLAR") {
        baseAlis = genelAyarlar.manuelDolarAlis; baseSatis = genelAyarlar.manuelDolarSatis;
    } else if (effectiveSource === "MANUEL_EURO") {
        baseAlis = genelAyarlar.manuelEuroAlis; baseSatis = genelAyarlar.manuelEuroSatis;
    } else {
        baseAlis = genelAyarlar.manuelHasAlis; baseSatis = genelAyarlar.manuelHasSatis;
    }

    const alisCarpan = parseFloat(formul.acilAlisCarpan || ((effectiveSource.startsWith("OTO_")) ? 1 : 0));
    const satisCarpan = parseFloat(formul.acilSatisCarpan || ((effectiveSource.startsWith("OTO_")) ? 1 : 0));

    const hAlis = baseAlis * alisCarpan;
    const hSatis = baseSatis * satisCarpan;

    return { alis: hAlis, satis: hSatis };
  };

  const getDynamicPrice = (urunAdi, islemTuru) => {
      const normalize = (text) => text ? text.toString().toLocaleLowerCase('tr-TR').trim() : "";
      const keyword = normalize(urunAdi);
      
      let foundFormul = formuller.find(f => normalize(f.ad) === keyword);
      if (!foundFormul) { foundFormul = formuller.find(f => normalize(f.ad).includes(keyword)); }

      if (!foundFormul) return 0;

      let result = { alis: 0, satis: 0 };
      if (genelAyarlar.aktif) {
          result = calculateAcil(foundFormul);
      } else {
          result = calculateNormal(foundFormul);
      }

      if (islemTuru === 'Alış') return result.alis;
      if (islemTuru === 'Satış') return result.satis;
      return 0;
  };

  const getAyarBazliBirimFiyat = (urun, kategori, islemTuru) => {
    if (!urun || (kategori !== 'Takı Ürün' && kategori !== 'Hurda')) return 0;

    // Takı/Hurda formül adı birebir eşleşmezse "14 Ayar", "22 Ayar" gibi ayar bazlı formülü dener.
    const ayarMatch = urun.match(/(\d+)\s*Ayar/i);
    if (!ayarMatch) return 0;

    const ayarEtiketi = `${ayarMatch[1]} Ayar`;
    let ayarFiyati = getDynamicPrice(ayarEtiketi, islemTuru);

    // 22 Ayar Bilezik için bazı kurulumlarda ayrı formül tutulabiliyor.
    if ((!ayarFiyati || ayarFiyati <= 0) && ayarMatch[1] === '22' && urun.toLocaleLowerCase('tr-TR').includes('bilezik')) {
      ayarFiyati = getDynamicPrice('22 Ayar Bilezik', islemTuru);
    }

    return ayarFiyati > 0 ? ayarFiyati : 0;
  };

  const getListeFiyati = (kategori, urun, islemTuru, adet = 1, gram = 1) => {
    if (!islemTuru || (islemTuru !== 'Alış' && islemTuru !== 'Satış') || !kategori || !urun || urun === 'TL - Türk Lirası') {
      return '';
    }
    if ((kategori === 'Takı Ürün' && islemTuru === 'Alış') || (kategori === 'Hurda' && islemTuru === 'Satış')) {
      return '';
    }

    const adetNum = parseFloat(adet) || 1;
    const gramNum = parseFloat(gram) || 1;

    // --- GÜMÜŞ ÖZEL HESAPLAMA MANTIĞI ---
    if (kategori === 'Genel' && urun === 'Gümüş') {
        const girilenGram = gramNum;
        
        let enYakin = gumusReferanslari[0];
        let minFark = Math.abs(girilenGram - enYakin.gr);

        for (let i = 1; i < gumusReferanslari.length; i++) {
            const fark = Math.abs(girilenGram - gumusReferanslari[i].gr);
            if (fark < minFark) {
                minFark = fark;
                enYakin = gumusReferanslari[i];
            }
        }
        
        const referansFiyat = getDynamicPrice(enYakin.ad, islemTuru);

        if (!referansFiyat || referansFiyat <= 0) return '';

        const birimFiyat = referansFiyat / enYakin.gr; 
        return (birimFiyat * girilenGram * adetNum).toFixed(2);
    }

    let birimFiyat = getDynamicPrice(urun, islemTuru);
    if ((!birimFiyat || birimFiyat <= 0) && (kategori === 'Takı Ürün' || kategori === 'Hurda')) {
      birimFiyat = getAyarBazliBirimFiyat(urun, kategori, islemTuru);
    }
    if (!birimFiyat || birimFiyat <= 0) return '';

    if (kategori === 'Sarrafiye' || kategori === 'Gram Altın' || kategori === 'Döviz') {
      return (birimFiyat * adetNum).toFixed(2);
    } else if (kategori === 'Takı Ürün' || kategori === 'Hurda' || kategori === 'Genel') {
      return (birimFiyat * adetNum * gramNum).toFixed(2);
    }
    return '';
  };

  useEffect(() => {
    const fetchUrunler = async () => {
      try {
        const urunlerSnapshot = await getDocs(collection(db, 'subeler', sube, 'urunler'));
        const urunlerData = urunlerSnapshot.docs.map(doc => ({
          id: doc.id,
          barkod: doc.data().barkod,
          isim: doc.data().isim || '',
          kategori: doc.data().kategori || '',
          urunTipi: doc.data().urunTipi || '',
          gram: doc.data().gram || 0,
          stok: doc.data().stok || 0
        }));
        setUrunListesi(urunlerData);
      } catch (err) {
        console.error('Ürün listesi alınamadı:', err);
        setHata('Ürün listesi yüklenemedi.');
      }
    };
    if (sube) {
      fetchUrunler();
    }
  }, [sube]);

  useEffect(() => {
    if (barkodSecildiRef.current) {
      // Listeden seçilen barkod input'a yazıldığında menüyü yeniden açma
      barkodSecildiRef.current = false;
      setShowBarkodDropdown(false);
      return;
    }
    if (barkod) {
      const filtered = urunListesi.filter(u => u.barkod.toLowerCase().includes(barkod.toLowerCase()));
      setFilteredUrunler(filtered);
      setShowBarkodDropdown(filtered.length > 0 && barkod.length > 0);
    } else {
      setFilteredUrunler([]);
      setShowBarkodDropdown(false);
    }
  }, [barkod, urunListesi]);

  useEffect(() => {
    const fetchMusteriler = async () => {
      try {
        const musterilerSnapshot = await getDocs(collection(db, 'subeler', sube, 'musteriler'));
        const musteriler = musterilerSnapshot.docs.map(doc => ({
          id: doc.id,
          ad: `${doc.data().isim || ''} ${doc.data().soyisim || ''}`.trim(),
          isim: doc.data().isim || '',
          soyisim: doc.data().soyisim || '',
          ...doc.data()
        }));
        setMusteriListesi(musteriler);
      } catch (err) {
        console.error('Müşteri listesi alınamadı:', err);
        setHata('Müşteri listesi yüklenemedi.');
      }
    };
    const fetchFirmalar = async () => {
      try {
        const firmalarSnapshot = await getDocs(collection(db, 'subeler', sube, 'firmalar'));
        const firmalar = firmalarSnapshot.docs.map(doc => ({
          id: doc.id,
          ad: doc.data().firmaIsmi || '',
          firmaIsmi: doc.data().firmaIsmi || '',
          ...doc.data()
        }));
        setFirmaListesi(firmalar);
      } catch (err) {
        console.error('Firma listesi alınamadı:', err);
        setHata('Firma listesi yüklenemedi.');
      }
    };
    if (sube) {
      fetchMusteriler();
      fetchFirmalar();
    } else {
      setHata('Şube bilgisi eksik.');
      navigate('/subesecimi');
    }
  }, [sube, navigate]);

  useEffect(() => {
    if (musteriInput) {
      const filtered = musteriListesi.filter(m => matchesSearch(musteriInput, m.ad));
      setFilteredMusteri(filtered);
      // Seçim yapıldıktan sonra input'a yazılan isim menüyü yeniden açmasın
      setShowMusteriDropdown(!selectedMusteri && filtered.length > 0 && musteriInput.length > 0);
    } else {
      setFilteredMusteri([]);
      setShowMusteriDropdown(false);
    }
  }, [musteriInput, musteriListesi, selectedMusteri]);

  useEffect(() => {
    if (firmaInput) {
      const filtered = firmaListesi.filter(f => matchesSearch(firmaInput, f.ad));
      setFilteredFirma(filtered);
      setShowFirmaDropdown(!selectedFirma && filtered.length > 0 && firmaInput.length > 0);
    } else {
      setFilteredFirma([]);
      setShowFirmaDropdown(false);
    }
  }, [firmaInput, firmaListesi, selectedFirma]);

  useEffect(() => {
    if (prices.length > 0 && islemTuru) {
      let sellPrice = 0;
      if (genelAyarlar.aktif) {
        sellPrice = genelAyarlar.manuelHasSatis;
      } else {
        const altinTry = getItem(prices, "ALTINTRY");
        sellPrice = altinTry.sell || 0;
      }

      setHasFiyati(sellPrice.toFixed(2).toString());
      setListeFiyati(getListeFiyati(kategori, urun, islemTuru, adet, gram));
    } else {
      setHasFiyati('');
      setListeFiyati('');
    }
  }, [islemTuru, prices, urun, kategori, adet, gram, formuller, genelAyarlar]);

  useEffect(() => {
    if (prices.length > 0 && isMultiMode) {
      let sellPrice = 0;
      if (genelAyarlar.aktif) {
        sellPrice = genelAyarlar.manuelHasSatis;
      } else {
        const altinTry = getItem(prices, "ALTINTRY");
        sellPrice = altinTry.sell || 0;
      }

      setMultiItems(prevItems =>
        prevItems.map(item => ({
          ...item,
          hasFiyati: item.islemTuru ? sellPrice.toFixed(2).toString() : '',
          listeFiyati: getListeFiyati(item.kategori, item.urun, item.islemTuru, item.adet, item.gram)
        }))
      );
    }
  }, [isMultiMode, prices, formuller, genelAyarlar]);

  const handleBarkodSelect = async (urun) => {
    try {
      const urunDoc = await getDoc(doc(db, 'subeler', sube, 'urunler', urun.id));
      if (urunDoc.exists()) {
        const data = urunDoc.data();
        // Aynı barkod tekrar seçilirse efekt çalışmaz; bayrak takılı kalmasın
        barkodSecildiRef.current = data.barkod !== barkod;
        setBarkod(data.barkod);
        setKategori(data.kategori || '');
        setUrun(data.urunTipi || '');
        setGram(data.gram ? data.gram.toString() : '');
        setUrunBilgisi(data.isim || '');
        setShowBarkodDropdown(false);
        setListeFiyati(getListeFiyati(data.kategori || '', data.urunTipi || '', islemTuru, adet, data.gram));
      }
    } catch (err) {
      setHata('Ürün bilgileri alınamadı.');
      console.error('Barkod seçimi hatası:', err);
    }
  };

  const handleMultiBarkodSelect = async (index, urun) => {
    try {
      const urunDoc = await getDoc(doc(db, 'subeler', sube, 'urunler', urun.id));
      if (urunDoc.exists()) {
        const data = urunDoc.data();
        const updatedItems = [...multiItems];
        updatedItems[index] = {
          ...updatedItems[index],
          barkod: data.barkod,
          kategori: data.kategori || '',
          urun: data.urunTipi || '',
          gram: data.gram ? data.gram.toString() : '',
          urunBilgisi: data.isim || '',
          listeFiyati: getListeFiyati(data.kategori || '', data.urunTipi || '', updatedItems[index].islemTuru, updatedItems[index].adet, data.gram)
        };
        setMultiItems(updatedItems);
        setShowBarkodDropdown(false);
      }
    } catch (err) {
      setHata('Ürün bilgileri alınamadı.');
      console.error('Barkod seçimi hatası:', err);
    }
  };

  const handleMultiBarkodChange = (index, value) => {
    const updatedItems = [...multiItems];
    updatedItems[index] = { ...updatedItems[index], barkod: value };
    setMultiItems(updatedItems);
    const filtered = urunListesi.filter(u => u.barkod.toLowerCase().includes(value.toLowerCase()));
    setFilteredUrunler(filtered);
    setShowBarkodDropdown(filtered.length > 0 && value.length > 0);
  };

  const handleMultiDateChange = (index, value) => {
    const updatedItems = [...multiItems];
    updatedItems[index] = { ...updatedItems[index], planlananTeslimTarihi: value };
    setMultiItems(updatedItems);
  };

  const handleNumberInput = useCallback((value, setter, index = null, kategori = null) => {
    const valForCheck = value.replace(',', '.');
    const regex = /^\d*\.?\d{0,3}$/;

    if (value === '' || regex.test(valForCheck)) {
      if (index !== null) {
        const updatedItems = [...multiItems];
        updatedItems[index] = { ...updatedItems[index], [setter]: value };
        updatedItems[index].listeFiyati = getListeFiyati(updatedItems[index].kategori, updatedItems[index].urun, updatedItems[index].islemTuru, updatedItems[index].adet, updatedItems[index].gram);
        setMultiItems(updatedItems);
      } else {
        setter(value);
        setListeFiyati(getListeFiyati(kategori, urun, islemTuru, adet, gram));
      }
    }
  }, [multiItems, kategori, urun, islemTuru, adet, gram, formuller, genelAyarlar]);

  const handleMultiItemChange = useCallback((index, field, value) => {
    const updatedItems = [...multiItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    if (field === 'kategori') {
      updatedItems[index].urun = '';
      updatedItems[index].gram = '';
      updatedItems[index].adet = '';
      updatedItems[index].listeFiyati = '';
    }
    if (field === 'islemTuru') {
      updatedItems[index].listeFiyati = getListeFiyati(updatedItems[index].kategori, updatedItems[index].urun, value, updatedItems[index].adet, updatedItems[index].gram);
      
      let sellPrice = 0;
      if (genelAyarlar.aktif) {
         sellPrice = genelAyarlar.manuelHasSatis;
      } else if (prices.length > 0) {
        const altinTry = getItem(prices, "ALTINTRY");
        sellPrice = altinTry.sell || 0;
      }
      updatedItems[index].hasFiyati = value ? sellPrice.toFixed(2).toString() : '';
    }
    if (field === 'urun') {
      updatedItems[index].listeFiyati = getListeFiyati(updatedItems[index].kategori, value, updatedItems[index].islemTuru, updatedItems[index].adet, updatedItems[index].gram);
      if (value === 'TL - Türk Lirası') {
        updatedItems[index].gram = '';
        updatedItems[index].adet = '';
      }
    }
    setMultiItems(updatedItems);
  }, [multiItems, prices, genelAyarlar, formuller]);

  const handleMultiTeslimatChange = (index, checked) => {
    const updatedItems = [...multiItems];
    updatedItems[index] = { ...updatedItems[index], teslimatDurumu: checked };
    setMultiItems(updatedItems);
  };

  const addMultiItem = () => {
    setMultiItems([...multiItems, {
      kategori: '',
      urun: '',
      islemTuru: '',
      gram: '',
      adet: '',
      hasFiyati: '',
      urunBilgisi: '',
      barkod: '',
      islemAciklamasi: '',
      bakiye: '',
      nakit: '',
      havaleEft: '',
      krediKarti: '',
      listeFiyati: '',
      hasEsdeger: '',
      teslimatDurumu: false 
    }]);
  };

  const removeMultiItem = (index) => {
    if (multiItems.length > 1) {
      setMultiItems(multiItems.filter((_, i) => i !== index));
    }
  };

  const genelToplamTutar = multiItems.reduce((total, item) => {
    const itemToplam = (parseFloat(item.nakit) || 0) + (parseFloat(item.havaleEft) || 0) + (parseFloat(item.krediKarti) || 0) + (parseFloat(item.bakiye) || 0);
    return total + itemToplam;
  }, 0).toFixed(2);
  
  const nakitGenelToplam = multiItems.reduce((total, item) => total + (parseFloat(item.nakit) || 0), 0).toFixed(2);
  const havaleEftGenelToplam = multiItems.reduce((total, item) => total + (parseFloat(item.havaleEft) || 0), 0).toFixed(2);
  const krediKartiGenelToplam = multiItems.reduce((total, item) => total + (parseFloat(item.krediKarti) || 0), 0).toFixed(2);

  const generateIslemNo = async () => {
    try {
      return await allocateIslemNo(sube);
    } catch (err) {
      console.error('İşlem numarası oluşturma hatası:', err);
      setHata('İşlem numarası oluşturulamadı.');
      return null;
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!sube) newErrors.sube = 'Şube seçilmeli';
    
    const firmaVar = !!selectedFirma || (firmaInput && firmaInput.trim().length > 0);

    if (!isMultiMode) {
      if (!kategori) newErrors.kategori = 'Kategori seçilmeli';
      if (!urun && kategori !== 'Genel') newErrors.urun = 'Ürün seçilmeli';
      if (!islemTuru) newErrors.islemTuru = 'İşlem türü seçilmeli';
      // TL'nin kendisi alinip satilan bir urun degil; sadece kasaya girer/cikar.
      // Personel doviz urununu secmeyi unutunca bu kayit olusuyordu (bkz. 12.10.2026).
      if (kategori === 'Döviz' && urun === 'TL - Türk Lirası' && (islemTuru === 'Alış' || islemTuru === 'Satış')) {
        newErrors.islemTuru = 'TL - Türk Lirası için Alış/Satış seçilemez. Döviz alıp satıyorsanız ürünü (örn. USD) seçin; kasaya nakit giriş/çıkışı için Giriş veya Çıkış kullanın.';
      }
      
      const isDecimalAllowed = kategori === 'Hurda' || kategori === 'Takı Ürün' || kategori === 'Genel';
      
      const gramRegex = isDecimalAllowed ? /^(\d*\.?\d{0,2})$/ : /^\d*$/;
      const adetRegex = /^\d*$/;
      if (kategori === 'Sarrafiye' || kategori === 'Gram Altın') {
        if (!adet || !adetRegex.test(adet) || parseInt(adet) <= 0) newErrors.adet = 'Geçerli bir adet girin';
        if (gram) newErrors.gram = 'Bu kategoride gram girilmez';
      } else if (kategori === 'Takı Ürün') {
        if (!adet || !adetRegex.test(adet) || parseInt(adet) <= 0) newErrors.adet = 'Geçerli bir adet girin';
        if (!gram || !gramRegex.test(gram) || parseFloat(gram) <= 0) newErrors.gram = 'Geçerli bir gram girin';
      } else if (kategori === 'Hurda') {
        if (!gram || !gramRegex.test(gram) || parseFloat(gram) <= 0) newErrors.gram = 'Geçerli bir gram girin';
        if (adet) newErrors.adet = 'Bu kategoride adet girilmez';
      } else if (kategori === 'Döviz' && urun !== 'TL - Türk Lirası') {
        if (!adet || !adetRegex.test(adet) || parseInt(adet) <= 0) newErrors.adet = 'Geçerli bir adet girin';
        if (gram) newErrors.gram = 'Bu kategoride gram girilmez';
      } else if (kategori === 'Döviz' && urun === 'TL - Türk Lirası') {
        if (gram) newErrors.gram = 'TL için gram girilmez';
        if (adet) newErrors.adet = 'TL için adet girilmez';
      } else if (kategori === 'Genel') {
        if (!gram && !adet) newErrors.gramAdet = 'Gram veya adet alanlarından en az biri doldurulmalı';
        if (gram && (!gramRegex.test(gram) || parseFloat(gram) <= 0)) newErrors.gram = 'Geçerli bir gram girin';
        if (adet && (!adetRegex.test(adet) || parseInt(adet) <= 0)) newErrors.adet = 'Geçerli bir adet girin';
      }
      if (urun !== 'TL - Türk Lirası' && (!hasFiyati || isNaN(hasFiyati) || parseFloat(hasFiyati) <= 0)) newErrors.hasFiyati = 'Geçerli bir has fiyatı girin';
      
      if (firmaVar) {
         const valToCheck = hasEsdeger.toString().replace(',','.');
         if (!hasEsdeger || isNaN(parseFloat(valToCheck)) || parseFloat(valToCheck) < 0) {
           newErrors.hasEsdeger = 'Firma işlemi için Has Eşdeğer (Gr) girmek zorunludur.';
         }
      }

    } else {
      multiItems.forEach((item, index) => {
        if (!item.kategori) newErrors[`kategori_${index}`] = `Satır ${index + 1}: Kategori seçilmeli`;
        if (!item.urun && item.kategori !== 'Genel') newErrors[`urun_${index}`] = `Satır ${index + 1}: Ürün seçilmeli`;
        if (!item.islemTuru) newErrors[`islemTuru_${index}`] = `Satır ${index + 1}: İşlem türü seçilmeli`;
        if (item.kategori === 'Döviz' && item.urun === 'TL - Türk Lirası' && (item.islemTuru === 'Alış' || item.islemTuru === 'Satış')) {
          newErrors[`islemTuru_${index}`] = `Satır ${index + 1}: TL - Türk Lirası için Alış/Satış seçilemez. Döviz alıp satıyorsanız ürünü (örn. USD) seçin; kasaya nakit giriş/çıkışı için Giriş veya Çıkış kullanın.`;
        }
        
        const isDecimalAllowed = item.kategori === 'Hurda' || item.kategori === 'Takı Ürün' || item.kategori === 'Genel';
        
        const gramRegex = isDecimalAllowed ? /^(\d*\.?\d{0,2})$/ : /^\d*$/;
        const adetRegex = /^\d*$/;
        if (item.kategori === 'Sarrafiye' || item.kategori === 'Gram Altın') {
          if (!item.adet || !adetRegex.test(item.adet) || parseInt(item.adet) <= 0) newErrors[`adet_${index}`] = `Satır ${index + 1}: Geçerli bir adet girin`;
          if (item.gram) newErrors[`gram_${index}`] = `Satır ${index + 1}: Bu kategoride gram girilmez`;
        } else if (item.kategori === 'Takı Ürün') {
          if (!item.adet || !adetRegex.test(item.adet) || parseInt(item.adet) <= 0) newErrors[`adet_${index}`] = `Satır ${index + 1}: Geçerli bir adet girin`;
          if (!item.gram || !gramRegex.test(item.gram) || parseFloat(item.gram) <= 0) newErrors[`gram_${index}`] = `Satır ${index + 1}: Geçerli bir gram girin`;
        } else if (item.kategori === 'Hurda') {
          if (!item.gram || !gramRegex.test(item.gram) || parseFloat(item.gram) <= 0) newErrors[`gram_${index}`] = `Satır ${index + 1}: Geçerli bir gram girin`;
          if (item.adet) newErrors[`adet_${index}`] = `Satır ${index + 1}: Bu kategoride adet girilmez`;
        } else if (item.kategori === 'Döviz' && item.urun !== 'TL - Türk Lirası') {
          if (!item.adet || !adetRegex.test(item.adet) || parseInt(item.adet) <= 0) newErrors[`adet_${index}`] = `Satır ${index + 1}: Geçerli bir adet girin`;
          if (item.gram) newErrors[`gram_${index}`] = `Satır ${index + 1}: Bu kategoride gram girilmez`;
        } else if (item.kategori === 'Döviz' && item.urun === 'TL - Türk Lirası') {
          if (item.gram) newErrors[`gram_${index}`] = `Satır ${index + 1}: TL için gram girilmez`;
          if (item.adet) newErrors[`adet_${index}`] = `Satır ${index + 1}: TL için adet girilmez`;
        } else if (item.kategori === 'Genel') {
          if (!item.gram && !item.adet) newErrors[`gramAdet_${index}`] = `Satır ${index + 1}: Gram veya adet alanlarından en az biri doldurulmalı`;
          if (item.gram && (!gramRegex.test(item.gram) || parseFloat(item.gram) <= 0)) newErrors[`gram_${index}`] = `Satır ${index + 1}: Geçerli bir gram girin`;
          if (item.adet && (!adetRegex.test(item.adet) || parseInt(item.adet) <= 0)) newErrors[`adet_${index}`] = `Satır ${index + 1}: Geçerli bir adet girin`;
        }
        if (item.urun !== 'TL - Türk Lirası' && (!item.hasFiyati || isNaN(item.hasFiyati) || parseFloat(item.hasFiyati) <= 0)) newErrors[`hasFiyati_${index}`] = `Satır ${index + 1}: Geçerli bir has fiyatı girin`;
        
        if (firmaVar) {
           const valToCheck = item.hasEsdeger.toString().replace(',','.');
           if (!item.hasEsdeger || isNaN(parseFloat(valToCheck)) || parseFloat(valToCheck) < 0) {
             newErrors[`hasEsdeger_${index}`] = `Satır ${index + 1}: Has Eşdeğer (Gr) girmek zorunludur`;
           }
        }
      });
    }
    if (!selectedMusteri && !selectedFirma && !musteriInput && !firmaInput) newErrors.musteri = 'Müşteri veya firma seçilmeli';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (!kayitBasariDialogAcik) return undefined;
    const t = setTimeout(() => setKayitBasariDialogAcik(false), 2000);
    return () => clearTimeout(t);
  }, [kayitBasariDialogAcik]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setHata('Lütfen tüm zorunlu alanları doğru doldurun.');
      return;
    }
    let musteriToSave = null;
    if (selectedMusteri) {
      musteriToSave = { id: selectedMusteri.id, isim: selectedMusteri.isim, soyisim: selectedMusteri.soyisim || '' };
    } else if (musteriInput) {
      const trimmedInput = musteriInput.trim();
      const spaceIndex = trimmedInput.lastIndexOf(' ');
      let isim, soyisim;
      if (spaceIndex === -1) {
        isim = trimmedInput;
        soyisim = '';
      } else {
        isim = trimmedInput.substring(0, spaceIndex).trim();
        soyisim = trimmedInput.substring(spaceIndex + 1).trim();
      }
      const matchedMusteri = findMusteriByTypedName(musteriListesi, trimmedInput);
      musteriToSave = matchedMusteri
        ? { id: matchedMusteri.id, isim: matchedMusteri.isim, soyisim: matchedMusteri.soyisim || '' }
        : { isim, soyisim };
    }
    let firmaToSave = null;
    if (selectedFirma) {
      firmaToSave = { id: selectedFirma.id, firmaIsmi: selectedFirma.firmaIsmi };
    } else if (firmaInput) {
      firmaToSave = { firmaIsmi: firmaInput.trim() };
    }
    try {
      const islemNo = await generateIslemNo();
      if (!islemNo) {
        setHata('İşlem numarası oluşturulamadı.');
        return;
      }
      let financeCtx = null;
      try {
        financeCtx = await loadFinanceCostContext(sube, { prices });
      } catch (financeErr) {
        console.warn('Maliyet bağlamı yüklenemedi, satış devam ediyor.', financeErr);
      }
      const withSnapshot = async (payload) => {
        try {
          return await attachFinanceSnapshotToIslem(payload, { sube, prices, context: financeCtx });
        } catch (snapErr) {
          console.warn('financeSnapshot yazılamadı', snapErr);
          return payload;
        }
      };
      if (isMultiMode) {
        const groupId = uuidv4();
        for (const [index, item] of multiItems.entries()) {
          // --- GÜNCELLEME: TOPLAM TUTAR = NAKİT + HAVALE + KART + BAKİYE ---
          const toplamTutar = (parseFloat(item.nakit) || 0) + (parseFloat(item.havaleEft) || 0) + (parseFloat(item.krediKarti) || 0) + (parseFloat(item.bakiye) || 0);
          
          // --- DÜZELTME: VERİ KAYDEDERKEN ONDALIK KONTROLÜ ---
          const isDecimalAllowed = item.kategori === 'Hurda' || item.kategori === 'Takı Ürün' || item.kategori === 'Genel';
          // ----------------------------------------------------
          
          const gramValue = isDecimalAllowed ? parseFloat(item.gram) || 0 : Math.floor(parseFloat(item.gram) || 0);
          const adetValue = parseInt(item.adet) || 0;

          const islemData = {
            islemNo: `${islemNo}/${index + 1}`,
            kategori: item.kategori,
            urun: item.urun,
            islemTuru: item.islemTuru,
            musteri: musteriToSave,
            firma: firmaToSave,
            barkod: item.barkod || null,
            gram: gramValue,
            adet: adetValue,
            urunBilgisi: item.urunBilgisi || null,
            islemAciklamasi: item.islemAciklamasi || null,
            hasFiyati: parseFloat(item.hasFiyati) || 0,
            bakiye: parseFloat(item.bakiye) || 0,
            nakit: parseFloat(item.nakit) || 0,
            havaleEft: parseFloat(item.havaleEft) || 0,
            krediKarti: parseFloat(item.krediKarti) || 0,
            toplamTutar: parseFloat(toplamTutar.toFixed(2)),
            listeFiyati: parseFloat(item.listeFiyati) || 0,
            hasEsdeger: parseFloat(item.hasEsdeger.toString().replace(',','.')) || 0,
            
            teslimatDurumu: item.teslimatDurumu ? "Teslimat Bekliyor" : "Teslim Edildi",
            planlananTeslimTarihi: item.teslimatDurumu ? item.planlananTeslimTarihi : null, // YENİ: Tarih Kaydı

            islemFisi: islemFisi || null,
            timestamp: serverTimestamp(),
            sube,
            isMulti: true,
            groupId,
            subNo: index + 1
          };
          const kayit = await withSnapshot(islemData);
          await addDoc(collection(db, 'subeler', sube, 'islemler'), kayit);

          // Stok Düşme (Beklemiyorsa ve Satışsa)
          if (!item.teslimatDurumu && item.islemTuru === 'Satış') {
             const dusulecekAdet = parseInt(item.adet) > 0 ? parseInt(item.adet) : 1;
             await updateStock(item.barkod, dusulecekAdet);
          }
        }
      } else {
        // --- GÜNCELLEME: TOPLAM TUTAR = NAKİT + HAVALE + KART + BAKİYE ---
        const toplamTutar = (parseFloat(nakit) || 0) + (parseFloat(havaleEft) || 0) + (parseFloat(krediKarti) || 0) + (parseFloat(bakiye) || 0);
        
        // --- DÜZELTME: VERİ KAYDEDERKEN ONDALIK KONTROLÜ ---
        const isDecimalAllowed = kategori === 'Hurda' || kategori === 'Takı Ürün' || kategori === 'Genel';
        // ----------------------------------------------------
        
        const gramValue = isDecimalAllowed ? parseFloat(gram) || 0 : Math.floor(parseFloat(gram) || 0);
        const adetValue = parseInt(adet) || 0;
        
        const islemData = {
          islemNo,
          kategori,
          urun,
          islemTuru,
          musteri: musteriToSave,
          firma: firmaToSave,
          barkod: barkod || null,
          gram: gramValue,
          adet: adetValue,
          urunBilgisi: urunBilgisi || null,
          islemAciklamasi: islemAciklamasi || null,
          hasFiyati: parseFloat(hasFiyati) || 0,
          bakiye: parseFloat(bakiye) || 0,
          nakit: parseFloat(nakit) || 0,
          havaleEft: parseFloat(havaleEft) || 0,
          krediKarti: parseFloat(krediKarti) || 0,
          toplamTutar: parseFloat(toplamTutar.toFixed(2)),
          listeFiyati: parseFloat(listeFiyati) || 0,
          hasEsdeger: parseFloat(hasEsdeger.toString().replace(',','.')) || 0,

          teslimatDurumu: teslimatDurumu ? "Teslimat Bekliyor" : "Teslim Edildi",
          planlananTeslimTarihi: teslimatDurumu ? planlananTeslimTarihi : null, // YENİ: Tarih Kaydı

          islemFisi: islemFisi || null,
          timestamp: serverTimestamp(),
          sube,
          isMulti: false
        };
        const kayit = await withSnapshot(islemData);
        await addDoc(collection(db, 'subeler', sube, 'islemler'), kayit);

        // Stok Düşme (Beklemiyorsa ve Satışsa)
        if (!teslimatDurumu && islemTuru === 'Satış') {
            const dusulecekAdet = parseInt(adet) > 0 ? parseInt(adet) : 1;
            await updateStock(barkod, dusulecekAdet);
        }
      }
      setKayitBasariDialogAcik(true);
      setHata('');
      setIsMultiMode(false);
      setMultiItems([{
        kategori: '',
        urun: '',
        islemTuru: '',
        gram: '',
        adet: '',
        hasFiyati: '',
        urunBilgisi: '',
        barkod: '',
        islemAciklamasi: '',
        bakiye: '',
        nakit: '',
        havaleEft: '',
        krediKarti: '',
        listeFiyati: '',
        hasEsdeger: '',
        teslimatDurumu: false,
        planlananTeslimTarihi: ''
      }]);
      setKategori('');
      setUrun('');
      setIslemTuru('');
      setMusteriInput('');
      setSelectedMusteri(null);
      setFirmaInput('');
      setSelectedFirma(null);
      setBarkod('');
      setGram('');
      setAdet('');
      setUrunBilgisi('');
      setIslemAciklamasi('');
      setHasFiyati('');
      setBakiye('');
      setHasEsdeger('');
      setNakit('');
      setHavaleEft('');
      setKrediKarti('');
      setListeFiyati('');
      setTeslimatDurumu(false); 
      setPlanlananTeslimTarihi(''); 
      setIslemFisi('');
      setErrors({});
      setShowMusteriDropdown(false);
      setShowFirmaDropdown(false);
      setShowBarkodDropdown(false);
    } catch (err) {
      setHata(`İşlem kaydedilemedi: ${err.message}`);
      console.error('Firestore Hatası:', err);
    }
  };
  const handlePrint = () => {
    window.print();
  };
  
  const musteriFirma = selectedMusteri || selectedFirma
      ? `${selectedMusteri ? `${selectedMusteri.isim || ''} ${selectedMusteri.soyisim || ''}`.trim() : ''}${selectedMusteri && selectedFirma ? ' / ' : ''}${selectedFirma ? selectedFirma.firmaIsmi || '' : ''}`
      : musteriInput || firmaInput || 'Belirtilmemiş';


  // --- HTML TABANLI PREMIUM FİŞ OLUŞTURUCU (GÖRSEL) ---
  const renderReceipt = () => {
      const now = new Date();
      const tarih = now.toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' });
      const saat = now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

      // Şube ismine göre başlık belirleme
      let headerTitle = "UKBA GOLD";
      const normalizedSube = sube ? sube.toUpperCase() : ""; // Büyük harfle kontrol
      
      if (normalizedSube.includes("SEFAKOY") || normalizedSube.includes("SEFAKÖY")) {
          headerTitle = "SOYLU KUYUMCULUK";
      } else if (normalizedSube.includes("KAVAKLI")) {
          headerTitle = "UKBA GOLD";
      }

      // Çoklu modda veya tekli modda gösterilecek kalemleri bir diziye atalım
      let itemsToRender = [];
      if (isMultiMode) {
          itemsToRender = multiItems;
      } else {
          itemsToRender = [{
              kategori, urun, islemTuru, gram, adet, hasFiyati, urunBilgisi, barkod, islemAciklamasi, bakiye, nakit, havaleEft, krediKarti, listeFiyati, hasEsdeger, teslimatDurumu, planlananTeslimTarihi
          }];
      }

      return (
          <div className="yi-receipt" style={{ padding: '16px 20px', fontFamily: "'Helvetica Neue', 'Arial', sans-serif", fontSize: '13px', color: '#1f2937', lineHeight: '1.45', height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', background: 'linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)' }}>
              {/* Header */}
              <div style={{ textAlign: 'center', marginBottom: '18px', borderBottom: '2px solid #d4b26a', paddingBottom: '8px' }}>
                  <h2 style={{ margin: '0', fontSize: '20px', fontWeight: '700', letterSpacing: '1.6px', color: '#0f2744', textTransform: 'uppercase' }}>{headerTitle}</h2>
                  <h3 style={{ margin: '0', fontSize: '11px', fontWeight: '500', letterSpacing: '4px', color: '#64748b', marginTop: '2px' }}>GOLD & JEWELRY</h3>
              </div>

              {/* Info Area */}
              <div style={{ marginBottom: '8px', fontSize: '12px', color: '#000' }}>
                  <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px', color: '#111827', marginBottom: '6px', paddingBottom:'4px', borderBottom:'1px solid #dbe2ea' }}>
                      {musteriFirma}
                  </div>
                  <div style={{ textAlign:'left', borderBottom:'1px solid #cfd8e3', paddingBottom:'4px', marginBottom:'4px' }}>
                      <div style={{ marginBottom:'1px' }}><strong>Şube:</strong> {sube ? sube.toUpperCase() : '-'}</div>
                      <div><strong>Tarih:</strong> {tarih} - {saat}</div>
                  </div>
              </div>

              {/* Items List */}
              <div style={{ flexGrow: 1, overflowY: 'auto' }}>
                  {itemsToRender.map((item, idx) => {
                      // Hesaplamalar
                      const totalItemVal = (parseFloat(item.nakit) || 0) + (parseFloat(item.havaleEft) || 0) + (parseFloat(item.krediKarti) || 0) + (parseFloat(item.bakiye) || 0);
                      const isDecimal = item.kategori === 'Hurda' || item.kategori === 'Takı Ürün' || item.kategori === 'Genel';
                      const gr = item.gram ? (isDecimal ? (parseFloat(item.gram) || 0).toFixed(2) : Math.floor(parseFloat(item.gram) || 0)) : null;
                      const ad = item.adet ? (parseInt(item.adet) || 0) : null;
                      
                      let miktarStr = "";
                      if (gr && ad) miktarStr = `${gr} Gr  |  ${ad} Adet`;
                      else if (gr) miktarStr = `${gr} Gr`;
                      else if (ad) miktarStr = `${ad} Adet`;

                      return (
                          <div key={idx} style={{ marginBottom: '12px', borderBottom: '1px dashed #d6dde8', paddingBottom: '8px' }}>
                              
                              {/* En Üst: İşlem Türü */}
                              <div style={{ textAlign: 'center', fontSize: '16px', fontWeight: '800', textTransform: 'uppercase', marginBottom: '4px', letterSpacing:'1px', color:'#0f4c81' }}>
                                  {item.islemTuru}
                              </div>
                              
                              {/* Kategori | Ürün */}
                              <div style={{ textAlign: 'center', fontSize: '14px', fontWeight: 'bold', marginBottom: '4px' }}>
                                   {item.kategori} <span style={{color:'#ccc', margin:'0 4px'}}>|</span> {item.urun}
                              </div>
                              
                              {/* Gram / Adet */}
                              {miktarStr && (
                                <div style={{ textAlign: 'center', fontSize: '13px', marginBottom: '6px', color:'#000', fontWeight:'500' }}>
                                    {miktarStr}
                                </div>
                              )}
                              
                              {(item.urunBilgisi || item.islemAciklamasi) && (
                                <div style={{ borderBottom:'1px dashed #ccc', marginBottom:'6px' }}></div>
                              )}
                              
                              {/* Notlar */}
                              {item.urunBilgisi && (
                                <div style={{ marginBottom: '6px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#333', textTransform: 'uppercase', marginBottom:'2px' }}>ÜRÜN BİLGİSİ</div>
                                    <div style={{ fontSize: '14px', fontStyle: 'italic', color: '#555' }}>{item.urunBilgisi}</div>
                                </div>
                              )}

                              {(item.urunBilgisi && item.islemAciklamasi) && (
                                 <div style={{ borderBottom:'1px solid #eee', width:'50%', margin:'4px auto' }}></div>
                              )}

                              {item.islemAciklamasi && (
                                <div style={{ marginTop: '4px', textAlign: 'center' }}>
                                    <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#333', textTransform: 'uppercase', marginBottom:'2px' }}>İŞLEM AÇIKLAMASI</div>
                                    <div style={{ fontSize: '14px', fontStyle: 'italic', color: '#555' }}>{item.islemAciklamasi}</div>
                                </div>
                              )}

                              {/* Bakiye Varsa Göster */}
                              {(parseFloat(item.bakiye) > 0) && (
                                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', color: '#d32f2f', fontWeight: 'bold', borderTop:'1px solid #eee', paddingTop:'4px', fontSize:'13px' }}>
                                      <span>Bakiye (Borç) Tutarı:</span>
                                      <span>{parseFloat(item.bakiye).toFixed(2)} TL</span>
                                  </div>
                              )}

                              {/* Teslimat Varsa Göster */}
                              {item.teslimatDurumu && (
                                  <div style={{ marginTop: '6px', padding: '4px', backgroundColor: '#fff8e1', borderRadius: '4px', fontSize: '11px', textAlign:'center', border:'1px solid #ffecb3' }}>
                                      <div style={{ fontWeight: 'bold', color: '#f57c00' }}>TESLİMAT BEKLİYOR</div>
                                      {item.planlananTeslimTarihi && (
                                          <div>Teslimat Tarihi: {new Date(item.planlananTeslimTarihi).toLocaleDateString('tr-TR')}</div>
                                      )}
                                  </div>
                              )}

                              {/* Tutar */}
                              <div style={{ marginTop: '8px', textAlign: 'center' }}>
                                  <div style={{ fontSize: '13px', fontWeight: 'bold', color:'#555', marginBottom:'0px' }}>TOPLAM TUTAR</div>
                                  <div style={{ fontSize: '18px', fontWeight: 'bold', color:'#000' }}>{totalItemVal.toFixed(2)} TL</div>
                              </div>
                          </div>
                      );
                  })}
              </div>

              {/* Footer / Grand Total (Only Multi) */}
              {isMultiMode && (
                  <div style={{ marginTop: 'auto', paddingTop: '10px', borderTop: '2px solid #c6d1de' }}>
                       <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '16px', fontWeight: 'bold' }}>
                          <span>GENEL TOPLAM</span>
                          <span>{genelToplamTutar} TL</span>
                       </div>
                  </div>
              )}
              
              <div style={{ textAlign: 'center', marginTop: 'auto', paddingTop:'15px', borderTop: '1px dashed #dbe3ec' }}>
                  <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '2px' }}>Allah bereket versin.</div>
                  <div style={{ fontSize: '10px', color: '#999', fontStyle: 'italic' }}>Teşekkür Ederiz</div>
              </div>
          </div>
      );
  };

  return (
    <div className="yeni-islem-page" style={{
      padding: '10px',
      fontFamily: "'Helvetica Neue', sans-serif",
      display: 'flex',
      gap: '12px',
      height: '100%',
      boxSizing: 'border-box',
      background: 'linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%)'
    }}>
      <form className="yeni-islem-form" onSubmit={handleSubmit} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        flex: '3',
        backgroundColor: '#ffffff',
        border: '1px solid #dbe3ee',
        borderRadius: '12px',
        padding: '14px',
        boxShadow: '0 6px 20px rgba(15, 23, 42, 0.06)'
      }}>
        <div style={{ borderBottom: '1px solid #e9edf2', paddingBottom: '8px', marginBottom: '2px' }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 700, color: '#1b1f24' }}>Yeni İşlem</h2>
          <p style={{ margin: '6px 0 0', fontSize: '15px', color: '#6b7280' }}>Müşteri veya firma seçin, ürün ve ödemeyi girin, işlemi kolayca yönetin.</p>
        </div>

        <div className="yi-multi-toggle" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', backgroundColor: '#faf7ef', border: '1px solid #efe2bf', borderRadius: '8px', padding: '8px 12px' }}>
          <label style={{ fontSize: '18px', color: '#3f3f3f', fontWeight: 600 }}>Çoklu işlem modu</label>
          <input
            type="checkbox"
            checked={isMultiMode}
            onChange={(e) => setIsMultiMode(e.target.checked)}
            style={{
              width: '20px',
              height: '20px',
              display: 'inline-block',
              visibility: 'visible',
              margin: '0',
              cursor: 'pointer'
            }}
          />
        </div>
        <div className="yi-top-row" style={{ display: 'flex', gap: '8px' }}>
          <div className="yi-card" style={{
            flex: '1',
            border: '1px solid #e3e7ef',
            borderRadius: '10px',
            padding: '10px',
            backgroundColor: '#fbfcfe'
          }}>
            <div className="yi-customer-row" style={{ display: 'flex', gap: '25px' }}>
              <div style={{ flex: '1', position: 'relative' }}>
                <input
                  type="text"
                  value={musteriInput}
                  onChange={(e) => {
                    setMusteriInput(e.target.value);
                    setSelectedMusteri(null);
                    setSelectedFirma(null);
                    setFirmaInput(''); 
                  }}
                  placeholder="Müşteri adı/ID *"
                  style={{
                    width: '100%',
                    height: '40px',
                    padding: '8px 50px 8px 4px',
                    fontSize: '20px',
                    borderRadius: '6px',
                    border: errors.musteri ? '1px solid red' : '1px solid #ccc',
                    boxSizing: 'border-box'
                  }}
                />
                <IconButton
                  type="button"
                  title="Yeni müşteri ekle"
                  aria-label="Yeni müşteri ekle"
                  onClick={() => setQuickCustomerModalOpen(true)}
                  size="small"
                  sx={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #c98a30 0%, #a8671d 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 6px rgba(168, 103, 29, 0.32)',
                    transition: 'background 0.15s ease, box-shadow 0.15s ease',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #b87a28 0%, #955d18 100%)',
                      boxShadow: '0 3px 10px rgba(149, 93, 24, 0.4)',
                    },
                    '&:active': {
                      transform: 'translateY(-50%) scale(0.96)',
                    },
                  }}
                >
                  <AddPlusIcon sx={{ fontSize: 20 }} />
                </IconButton>
                {showMusteriDropdown && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: '0',
                    right: '0',
                    maxHeight: '150px',
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    zIndex: 10
                  }}>
                    {filteredMusteri.map((m, index) => (
                      <div
                        key={index}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => {
                          setMusteriInput(m.ad);
                          setSelectedMusteri({ id: m.id, isim: m.isim, soyisim: m.soyisim });
                          setShowMusteriDropdown(false);
                        }}
                        style={{
                          padding: '8px',
                          cursor: 'pointer',
                          backgroundColor: '#f9f9f9'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#f9f9f9'}
                      >
                        {m.ad}
                      </div>
                    ))}
                  </div>
                )}
                {errors.musteri && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.musteri}</p>}
              </div>
              <div style={{ flex: '1', position: 'relative' }}>
                <input
                  type="text"
                  value={firmaInput}
                  onChange={(e) => {
                    setFirmaInput(e.target.value);
                    setSelectedFirma(null);
                    setSelectedMusteri(null); 
                    setMusteriInput('');
                  }}
                  placeholder="Firma adı/ID *"
                  style={{
                    width: '100%',
                    height: '40px',
                    padding: '8px 50px 8px 4px',
                    fontSize: '20px',
                    borderRadius: '6px',
                    border: errors.musteri ? '1px solid red' : '1px solid #ccc',
                    boxSizing: 'border-box'
                  }}
                />
                <IconButton
                  type="button"
                  title="Yeni firma ekle"
                  aria-label="Yeni firma ekle"
                  onClick={() => setQuickCompanyModalOpen(true)}
                  size="small"
                  sx={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #c98a30 0%, #a8671d 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 6px rgba(168, 103, 29, 0.32)',
                    transition: 'background 0.15s ease, box-shadow 0.15s ease',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #b87a28 0%, #955d18 100%)',
                      boxShadow: '0 3px 10px rgba(149, 93, 24, 0.4)',
                    },
                    '&:active': {
                      transform: 'translateY(-50%) scale(0.96)',
                    },
                  }}
                >
                  <AddPlusIcon sx={{ fontSize: 20 }} />
                </IconButton>
                {showFirmaDropdown && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: '0',
                    right: '0',
                    maxHeight: '150px',
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    zIndex: 10
                  }}>
                    {filteredFirma.map((f, index) => (
                      <div
                        key={index}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => {
                          setFirmaInput(f.ad);
                          setSelectedFirma({ id: f.id, firmaIsmi: f.firmaIsmi });
                          setShowFirmaDropdown(false);
                        }}
                        style={{
                          padding: '8px',
                          cursor: 'pointer',
                          backgroundColor: '#f9f9f9'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#f9f9f9'}
                      >
                        {f.ad}
                      </div>
                    ))}
                  </div>
                )}
                {errors.musteri && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.musteri}</p>}
              </div>
            </div>
          </div>
          {!isMultiMode && (
            <div className="yi-card" style={{
              flex: '1',
              border: '1px solid #e3e7ef',
              borderRadius: '10px',
              padding: '10px',
              backgroundColor: '#fbfcfe'
            }}>
              <div className="yi-type-row" style={{ display: 'flex', gap: '8px' }}>
                <div style={{ flex: '1' }}>
                  <select
                    value={islemTuru}
                    onChange={(e) => setIslemTuru(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 4px',
                      fontSize: '20px',
                      borderRadius: '6px',
                      border: errors.islemTuru ? '1px solid red' : '1px solid #ccc',
                      boxSizing: 'border-box'
                    }}
                  >
                    <option value="">İşlem Türü *</option>
                    {islemTurleri.map((tur) => (
                      <option key={tur} value={tur}>{tur}</option>
                    ))}
                  </select>
                  {errors.islemTuru && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.islemTuru}</p>}
                </div>
                <div style={{ flex: '1' }}>
                  <select
                    value={kategori}
                    onChange={(e) => {
                      setKategori(e.target.value);
                      setUrun('');
                      setGram('');
                      setAdet('');
                      setListeFiyati('');
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 4px',
                      fontSize: '20px',
                      borderRadius: '6px',
                      border: errors.kategori ? '1px solid red' : '1px solid #ccc',
                      boxSizing: 'border-box'
                    }}
                  >
                    <option value="">Kategori *</option>
                    {kategoriler.map((kat) => (
                      <option key={kat} value={kat}>{kat}</option>
                    ))}
                  </select>
                  {errors.kategori && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.kategori}</p>}
                </div>
                <div style={{ flex: '1' }}>
                  <select
                    value={urun}
                    onChange={(e) => {
                      setUrun(e.target.value);
                      if (e.target.value === 'TL - Türk Lirası') {
                        setGram('');
                        setAdet('');
                        setListeFiyati('');
                      } else {
                        setListeFiyati(getListeFiyati(kategori, e.target.value, islemTuru, adet, gram));
                      }
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 4px',
                      fontSize: '20px',
                      borderRadius: '6px',
                      border: errors.urun ? '1px solid red' : '1px solid #ccc',
                      boxSizing: 'border-box'
                    }}
                    disabled={!kategori} 
                  >
                    <option value="">Ürün *</option>
                    {kategori && urunler[kategori]?.map((urunAdi) => (
                      <option key={urunAdi} value={urunAdi}>{urunAdi}</option>
                    ))}
                  </select>
                  {errors.urun && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.urun}</p>}
                </div>
              </div>
            </div>
          )}
        </div>
        {isMultiMode ? (
          <div className="yi-card yi-multi-card" style={{
            flex: '1',
            border: '1px solid #e3e7ef',
            borderRadius: '10px',
            padding: '10px',
            backgroundColor: '#fbfcfe',
            maxHeight: multiItems.length > 1 ? '500px' : 'none',
            overflowY: multiItems.length > 1 ? 'auto' : 'visible'
          }}>
            {multiItems.map((item, index) => (
              <div key={index} className="yi-multi-item" style={{ borderBottom: '1px solid #ccc', padding: '8px 0', marginBottom: '8px' }}>
                <div className="yi-multi-row" style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
                  <div style={{ width: '270px' }}>
                    <select
                      value={item.islemTuru}
                      onChange={(e) => handleMultiItemChange(index, 'islemTuru', e.target.value)}
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`islemTuru_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    >
                      <option value="">İşlem Türü *</option>
                      {islemTurleri.map((tur) => (
                        <option key={tur} value={tur}>{tur}</option>
                      ))}
                    </select>
                    {errors[`islemTuru_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`islemTuru_${index}`]}</p>}
                  </div>
                  <div style={{ width: '270px' }}>
                    <select
                      value={item.kategori}
                      onChange={(e) => handleMultiItemChange(index, 'kategori', e.target.value)}
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`kategori_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    >
                      <option value="">Kategori *</option>
                      {kategoriler.map((kat) => (
                        <option key={kat} value={kat}>{kat}</option>
                      ))}
                    </select>
                    {errors[`kategori_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`kategori_${index}`]}</p>}
                  </div>
                  <div style={{ width: '270px' }}>
                    <select
                      value={item.urun}
                      onChange={(e) => handleMultiItemChange(index, 'urun', e.target.value)}
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`urun_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                      disabled={!item.kategori}
                    >
                      <option value="">Ürün *</option>
                      {item.kategori && urunler[item.kategori]?.map((urunAdi) => (
                        <option key={urunAdi} value={urunAdi}>{urunAdi}</option>
                      ))}
                    </select>
                    {errors[`urun_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`urun_${index}`]}</p>}
                  </div>
                  <div style={{ width: '270px', position: 'relative' }}>
                    <input
                      type="text"
                      value={item.barkod}
                      onChange={(e) => handleMultiBarkodChange(index, e.target.value)}
                      placeholder="Barkod"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                    {showBarkodDropdown && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '0',
                        right: '0',
                        maxHeight: '150px',
                        overflowY: 'auto',
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        zIndex: 10
                      }}>
                        {filteredUrunler.map((u, idx) => (
                          <div
                            key={idx}
                            onClick={() => handleMultiBarkodSelect(index, u)}
                            style={{
                              padding: '8px',
                              cursor: 'pointer',
                              backgroundColor: '#f9f9f9'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#f9f9f9'}
                          >
                            {u.barkod} ({u.isim})
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="yi-multi-row" style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.gram}
                      onChange={(e) => handleNumberInput(e.target.value, 'gram', index, item.kategori)}
                      placeholder="Gram"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`gram_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                      disabled={item.kategori === 'Sarrafiye' || item.kategori === 'Gram Altın' || item.kategori === 'Döviz'}
                    />
                    {errors[`gram_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`gram_${index}`]}</p>}
                  </div>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.adet}
                      onChange={(e) => handleNumberInput(e.target.value, 'adet', index)}
                      placeholder="Adet"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`adet_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                      disabled={item.kategori === 'Hurda' || (item.kategori === 'Döviz' && item.urun === 'TL - Türk Lirası')}
                    />
                    {errors[`adet_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`adet_${index}`]}</p>}
                    {errors[`gramAdet_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`gramAdet_${index}`]}</p>}
                  </div>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.urunBilgisi}
                      onChange={(e) => handleMultiItemChange(index, 'urunBilgisi', e.target.value)}
                      placeholder="Ürün Bilgisi"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                  </div>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.hasFiyati}
                      onChange={(e) => handleNumberInput(e.target.value, 'hasFiyati', index)}
                      placeholder="Has Fiyatı *"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`hasFiyati_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                      readOnly={!!item.islemTuru || item.urun === 'TL - Türk Lirası'}
                    />
                    {errors[`hasFiyati_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`hasFiyati_${index}`]}</p>}
                  </div>
                </div>
                <div className="yi-multi-row" style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
                  <div style={{ width: '270px' }}>
                    <textarea
                      value={item.islemAciklamasi}
                      onChange={(e) => handleMultiItemChange(index, 'islemAciklamasi', e.target.value)}
                      placeholder="İşlem Açıklaması"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        resize: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                  </div>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.bakiye}
                      onChange={(e) => handleNumberInput(e.target.value, 'bakiye', index)}
                      placeholder="Bakiye"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                  </div>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.nakit}
                      onChange={(e) => handleNumberInput(e.target.value, 'nakit', index)}
                      placeholder="Nakit"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors[`nakit_${index}`] ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                    {errors[`nakit_${index}`] && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors[`nakit_${index}`]}</p>}
                  </div>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.havaleEft}
                      onChange={(e) => handleNumberInput(e.target.value, 'havaleEft', index)}
                      placeholder="Havale/EFT"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                  </div>
                </div>
                <div className="yi-multi-row" style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap' }}>
                  <div style={{ width: '270px' }}>
                    <input
                      type="text"
                      value={item.krediKarti}
                      onChange={(e) => handleNumberInput(e.target.value, 'krediKarti', index)}
                      placeholder="Kredi Kartı"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        lineHeight: 'normal'
                      }}
                    />
                  </div>
                  <div style={{ width: '270px' }}>
                    {(item.islemTuru === 'Alış' || item.islemTuru === 'Satış') && (
                      <div>
                        <input
                          type="text"
                          value={item.listeFiyati}
                          readOnly
                          placeholder="Liste Fiyatı"
                          style={{
                            width: '100%',
                            height: '40px',
                            padding: '8px 4px',
                            fontSize: '16px',
                            borderRadius: '6px',
                            border: '1px solid #ccc',
                            boxSizing: 'border-box',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            MozAppearance: 'none',
                            lineHeight: 'normal',
                            backgroundColor: '#e9ecef'
                          }}
                        />
                      </div>
                    )}
                  </div>
                  
                  {isFirmaSelected && (
                    <div style={{ width: '270px' }}>
                      <input 
                        type="text" 
                        value={item.hasEsdeger} 
                        onChange={(e)=>handleNumberInput(e.target.value, 'hasEsdeger', index)} 
                        placeholder="Has Eşdeğer (Gr) *"
                        style={{
                          width: '100%', height: '40px', fontSize: '16px', borderRadius: '6px', 
                          border: errors[`hasEsdeger_${index}`] ? '2px solid red' : '2px solid #ed6c02',
                          backgroundColor: '#fff7e6', fontWeight: 'bold', color: '#e65100',
                          boxSizing: 'border-box', padding: '8px 4px'
                        }} 
                      />
                      {errors[`hasEsdeger_${index}`] && <p style={{color:'red', fontSize:'12px', marginTop:'2px'}}>{errors[`hasEsdeger_${index}`]}</p>}
                    </div>
                  )}

                  {/* YENİ: TESLİMAT BİLGİSİ (Çoklu Mod) */}
                  <div style={{ width: '270px', display: 'flex', alignItems: 'center' }}>
                      <label style={{ fontSize: '14px', marginRight: '8px', color:'#d32f2f', fontWeight:'bold' }}>Teslimat Bekliyor:</label>
                      <input type="checkbox" checked={item.teslimatDurumu} onChange={(e) => handleMultiTeslimatChange(index, e.target.checked)} style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
                  </div>
                  
                  {item.teslimatDurumu && (
                        <div style={{ width: '270px' }}>
                            <input 
                                type="date" 
                                value={item.planlananTeslimTarihi} 
                                onChange={(e) => handleMultiDateChange(index, e.target.value)}
                                style={{ width:'100%', height:'40px', borderRadius:'6px', border:'1px solid #ccc', padding:'0 5px' }}
                            />
                        </div>
                  )}

                  <div style={{ width: '270px' }}>
                    <p style={{ fontSize: '16px', fontWeight: 'bold', margin: '0' }}>
                      Toplam Tutar: {((parseFloat(item.nakit) || 0) + (parseFloat(item.havaleEft) || 0) + (parseFloat(item.krediKarti) || 0) + (parseFloat(item.bakiye) || 0)).toFixed(2)} TL
                    </p>
                  </div>
                  <div style={{ width: '150px', marginLeft: 'auto' }}>
                    <button
                      type="button"
                      onClick={() => removeMultiItem(index)}
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '8px 4px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: 'none',
                        backgroundColor: '#dc2626',
                        color: '#fff',
                        cursor: 'pointer'
                      }}
                      disabled={multiItems.length === 1}
                    >
                      Sil
                    </button>
                  </div>
                </div>
              </div>
            ))}
            <div className="yi-multi-footer" style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '8px', flexWrap: 'wrap', gap: '8px' }}>
              <button
                type="button"
                onClick={addMultiItem}
                style={{
                  width: '150px',
                  height: '40px',
                  padding: '8px 4px',
                  fontSize: '16px',
                  borderRadius: '6px',
                  border: 'none',
                  backgroundColor: '#10b981',
                  color: '#fff',
                  cursor: 'pointer'
                }}
              >
                Satır Ekle
              </button>
              <div className="yi-multi-footer" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#000', margin: '0' }}>
                  Nakit Genel Toplam: {nakitGenelToplam} TL
                </p>
                <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#000', margin: '0' }}>
                  Havale/EFT Genel Toplam: {havaleEftGenelToplam} TL
                </p>
                <p style={{ fontSize: '14px', fontWeight: 'bold', color: '#000', margin: '0' }}>
                  Kredi Kartı Genel Toplam: {krediKartiGenelToplam} TL
                </p>
                <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#000', margin: '0' }}>
                  Genel Toplam Tutar: {genelToplamTutar} TL
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="yi-single-layout" style={{ display: 'flex', gap: '8px' }}>
            <div className="yi-card yi-single-left" style={{
              flex: '1',
              height: '380px',
              border: '1px solid #dce3ee',
              borderRadius: '10px',
              padding: '10px',
              backgroundColor: '#fbfcfe',
              display: 'flex',
              flexDirection: 'column',
              gap: '6px'
            }}>
              <div className="yi-mobile-row yi-mobile-row-2">
                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Barkod</label>
                  <div className="yi-control" style={{ flex: '1', maxWidth: '45%', position: 'relative' }}>
                    <input
                      type="text"
                      value={barkod}
                      onChange={(e) => setBarkod(e.target.value)}
                      placeholder="Barkod"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box'
                      }}
                    />
                    {showBarkodDropdown && (
                      <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '0',
                        right: '0',
                        maxHeight: '150px',
                        overflowY: 'auto',
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        zIndex: 10
                      }}>
                        {filteredUrunler.map((u, index) => (
                          <div
                            key={index}
                            onClick={() => handleBarkodSelect(u)}
                            style={{
                              padding: '8px',
                              cursor: 'pointer',
                              backgroundColor: '#f9f9f9'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#e0e0e0'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#f9f9f9'}
                          >
                            {u.barkod} ({u.isim})
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Gram</label>
                  <div className="yi-control" style={{ flex: '1', maxWidth: '45%' }}>
                    <input
                      type="text"
                      value={gram}
                      onChange={(e) => handleNumberInput(e.target.value, setGram, null, kategori)}
                      placeholder="Gram"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors.gram ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                      disabled={kategori === 'Sarrafiye' || kategori === 'Gram Altın' || kategori === 'Döviz' || !kategori}
                    />
                    {errors.gram && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.gram}</p>}
                  </div>
                </div>
              </div>

              <div className="yi-mobile-row yi-mobile-row-2">
                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Adet</label>
                  <div className="yi-control" style={{ flex: '1', maxWidth: '45%' }}>
                    <input
                      type="text"
                      value={adet}
                      onChange={(e) => handleNumberInput(e.target.value, setAdet)}
                      placeholder="Adet"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors.adet ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                      disabled={kategori === 'Hurda' || (kategori === 'Döviz' && urun === 'TL - Türk Lirası') || !kategori}
                    />
                    {errors.adet && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.adet}</p>}
                    {errors.gramAdet && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.gramAdet}</p>}
                  </div>
                </div>

                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Ürün Bilgisi</label>
                  <div className="yi-control" style={{ flex: '1', maxWidth: '45%' }}>
                    <input
                      type="text"
                      value={urunBilgisi}
                      onChange={(e) => setUrunBilgisi(e.target.value)}
                      placeholder="Ürün Bilgisi"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box'
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="yi-mobile-row yi-mobile-row-2">
                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Has Fiyatı *</label>
                  <div className="yi-control" style={{ flex: '1', maxWidth: '45%' }}>
                    <input
                      type="text"
                      value={hasFiyati}
                      onChange={(e) => handleNumberInput(e.target.value, setHasFiyati)}
                      placeholder="Has Fiyatı"
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors.hasFiyati ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                      readOnly={!!islemTuru || urun === 'TL - Türk Lirası'}
                    />
                    {errors.hasFiyati && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.hasFiyati}</p>}
                  </div>
                </div>

                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>İşlem Açıklaması</label>
                  <div className="yi-control" style={{ flex: '1', maxWidth: '45%' }}>
                    <textarea
                      value={islemAciklamasi}
                      onChange={(e) => setIslemAciklamasi(e.target.value)}
                      placeholder="İşlem Açıklaması"
                      style={{
                        width: '100%',
                        height: '60px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        resize: 'none',
                        boxSizing: 'border-box'
                      }}
                    />
                  </div>
                </div>
              </div>
              
              {/* YENİ: TESLİMAT BİLGİSİ (Tekli Mod) */}
              <div
                className="yi-delivery-box"
                style={{ display: 'flex', flexDirection:'column', gap:'5px', marginTop: '5px', backgroundColor:'#fff0f0', padding:'5px', borderRadius:'5px' }}
              >
                <div className="yi-delivery-row" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <label style={{ fontSize: '20px', color: '#d32f2f', fontWeight:'bold' }}>Teslimat Bekliyor</label>
                    <input type="checkbox" checked={teslimatDurumu} onChange={(e) => setTeslimatDurumu(e.target.checked)} style={{ width: '25px', height: '25px', cursor: 'pointer' }} />
                </div>
                
                {teslimatDurumu && (
                    <div className="yi-delivery-date-row" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <label style={{ fontSize: '16px', fontWeight:'bold' }}>Planlanan Tarih:</label>
                        <input 
                            type="date" 
                            value={planlananTeslimTarihi} 
                            onChange={(e) => setPlanlananTeslimTarihi(e.target.value)}
                            style={{ height:'35px', borderRadius:'4px', border:'1px solid #ccc', fontSize:'16px' }}
                        />
                    </div>
                )}
              </div>

            </div>
            
            <div className="yi-card yi-single-right" style={{
              flex: '1',
              height: '380px',
              border: '1px solid #dce3ee',
              borderRadius: '10px',
              padding: '10px',
              backgroundColor: '#fbfcfe',
              display: 'flex',
              flexDirection: 'column',
              gap: '6px'
            }}>
              <div className="yi-mobile-row yi-mobile-row-3">
                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Nakit</label>
                  <div className="yi-control" style={{ flex: '1' }}>
                    <input
                      type="text"
                      value={nakit}
                      onChange={(e) => handleNumberInput(e.target.value, setNakit)}
                      placeholder="Nakit"
                      style={{
                        width: '250px',
                        height: '40px',
                        padding: '6px 2px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: errors.nakit ? '1px solid red' : '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                    />
                    {errors.nakit && <p style={{ color: 'red', fontSize: '12px', marginTop: '2px' }}>{errors.nakit}</p>}
                  </div>
                </div>

                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Havale/EFT</label>
                  <div className="yi-control" style={{ flex: '1' }}>
                    <input
                      type="text"
                      value={havaleEft}
                      onChange={(e) => handleNumberInput(e.target.value, setHavaleEft)}
                      placeholder="Havale"
                      style={{
                        width: '250px',
                        height: '40px',
                        padding: '6px 2px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                    />
                  </div>
                </div>

                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Kredi Kartı</label>
                  <div className="yi-control" style={{ flex: '1' }}>
                    <input
                      type="text"
                      value={krediKarti}
                      onChange={(e) => handleNumberInput(e.target.value, setKrediKarti)}
                      placeholder="Kredi"
                      style={{
                        width: '250px',
                        height: '40px',
                        padding: '6px 2px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                    />
                  </div>
                </div>
              </div>
              {(islemTuru === 'Alış' || islemTuru === 'Satış') && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Liste Fiyatı</label>
                  <input
                    type="text"
                    value={listeFiyati}
                    readOnly
                    placeholder="Liste Fiyatı"
                    style={{
                      width: '250px',
                      height: '40px',
                      padding: '6px 2px',
                      fontSize: '16px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      boxSizing: 'border-box',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      backgroundColor: '#e9ecef'
                    }}
                  />
                </div>
              )}
              <div className="yi-mobile-row yi-mobile-row-1">
                <div className="yi-field" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <label style={{ fontSize: '20px', color: '#000', width: '160px' }}>Bakiye</label>
                  <div className="yi-control" style={{ flex: '1' }}>
                    <input
                      type="text"
                      value={bakiye}
                      onChange={(e) => handleNumberInput(e.target.value, setBakiye)}
                      placeholder="Bakiye"
                      style={{
                        width: '45%',
                        height: '40px',
                        padding: '5px 1px',
                        fontSize: '16px',
                        borderRadius: '6px',
                        border: '1px solid #ccc',
                        boxSizing: 'border-box',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none'
                      }}
                    />
                  </div>
                </div>

                <div className="yi-field yi-field-hasesdeger">
                  {isFirmaSelected ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop:'10px', padding:'5px', border:'2px dashed #ed6c02', borderRadius:'8px', backgroundColor:'#fff7e6' }}>
                      <label style={{ fontSize: '20px', fontWeight: 'bold', color: '#e65100', width: '160px' }}>Has Eşdeğer (Gr)*</label>
                      <input
                        type="text"
                        value={hasEsdeger}
                        onChange={(e) => handleNumberInput(e.target.value, setHasEsdeger)}
                        placeholder="Zorunlu Alan"
                        style={{
                          width: '250px',
                          height: '45px',
                          padding: '6px 2px',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          borderRadius: '6px',
                          border: errors.hasEsdeger ? '2px solid red' : '1px solid #ccc',
                          boxSizing: 'border-box'
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <label style={{ fontSize: '20px', color: '#000', width: '160px', fontWeight: 'bold' }}>Toplam Tutar</label>
                <p style={{ fontSize: '20px', color: '#000', fontWeight: 'bold' }}>
                  {((parseFloat(nakit) || 0) + (parseFloat(havaleEft) || 0) + (parseFloat(krediKarti) || 0) + (parseFloat(bakiye) || 0)).toFixed(2)} TL
                </p>
              </div>
            </div>
          </div>
        )}
        <button
          type="submit"
          className="primary-save-button"
          style={{
            width: '250px',
            padding: '8px',
            fontSize: '18px',
            fontWeight: 700,
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#b96a1a',
            color: '#fff',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
            margin: '8px auto',
            boxShadow: '0 2px 8px rgba(185, 106, 26, 0.35)'
          }}
          onMouseEnter={(e) => {
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              e.target.style.backgroundColor = '#9f5c17';
            }
          }}
          onMouseLeave={(e) => {
            if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
              e.target.style.backgroundColor = '#b96a1a';
            }
          }}
        >
          Kaydet
        </button>
        {hata && <p style={{ fontSize: '16px', color: 'red', marginTop: '8px' }}>{hata}</p>}
      </form>
      <div className="print-area" style={{
        flex: '0 0 360px',
        borderRadius: '12px',
        padding: '0', 
        background: '#f8fafc',
        boxShadow: '0 8px 22px rgba(15, 23, 42, 0.10)',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        border: '1px solid #d8e0eb',
        height: '700px',
        overflow: 'hidden'
      }}>
        <div style={{
             width: '100%',
             height: '640px',
             backgroundColor: '#fff',
             padding: '15px 20px',
             boxSizing: 'border-box',
             fontFamily: "'Helvetica Neue', 'Arial', sans-serif",
             color: '#333',
             fontSize: '13px',
             overflowY: 'auto'
        }}>
            {renderReceipt()}
        </div>

        <button
          onClick={handlePrint}
          style={{
            margin: '0 10px 10px 10px',
            padding: '8px',
            fontSize: '17px',
            fontWeight: 600,
            fontFamily: "'Roboto', sans-serif",
            borderRadius: '6px',
            border: 'none',
            backgroundColor: '#0f2744',
            color: '#fff',
            cursor: 'pointer',
            transition: 'background-color 0.3s'
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#16365c'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#0f2744'}
        >
          Yazdır
        </button>
      </div>
      <Dialog
        open={kayitBasariDialogAcik}
        onClose={() => {}}
        disableEscapeKeyDown
        slotProps={{
          backdrop: { sx: { backgroundColor: 'rgba(15, 23, 42, 0.45)' } }
        }}
        PaperProps={{
          elevation: 12,
          sx: {
            borderRadius: '22px',
            minWidth: { xs: 'min(92vw, 520px)', sm: 520 },
            maxWidth: 580,
            width: { xs: '92vw', sm: 'auto' },
            textAlign: 'center',
            overflow: 'hidden',
            background: 'linear-gradient(155deg, #14532d 0%, #16a34a 38%, #22c55e 62%, #166534 100%)',
            border: '2px solid rgba(255, 255, 255, 0.4)',
            boxShadow: '0 28px 70px rgba(22, 101, 52, 0.55), inset 0 1px 0 rgba(255,255,255,0.25)'
          }
        }}
      >
        <DialogContent sx={{ py: { xs: 4, sm: 5.5 }, px: { xs: 3, sm: 5 } }}>
          <Typography
            variant="h5"
            component="p"
            sx={{
              fontWeight: 900,
              color: '#fff',
              mb: 2,
              fontSize: { xs: '1.5rem', sm: '1.85rem' },
              lineHeight: 1.25,
              letterSpacing: '0.02em',
              textShadow: '0 2px 8px rgba(0, 0, 0, 0.25)'
            }}
          >
            Yeni işlem kaydedildi
          </Typography>
          <Typography
            variant="h6"
            component="p"
            sx={{
              fontWeight: 700,
              color: 'rgba(255, 255, 255, 0.96)',
              lineHeight: 1.45,
              fontSize: { xs: '1.05rem', sm: '1.2rem' },
              textShadow: '0 1px 4px rgba(0, 0, 0, 0.2)'
            }}
          >
            İşlem başarıyla kaydedildi.
          </Typography>
        </DialogContent>
      </Dialog>
      <QuickCustomerAddModal
        open={quickCustomerModalOpen}
        onClose={() => setQuickCustomerModalOpen(false)}
        sube={sube}
        onSuccess={handleQuickCustomerAdded}
      />
      <QuickCompanyAddModal
        open={quickCompanyModalOpen}
        onClose={() => setQuickCompanyModalOpen(false)}
        sube={sube}
        onSuccess={handleQuickCompanyAdded}
      />
      <style>
        {`
          .yeni-islem-page .yeni-islem-form label {
            font-size: 17px !important;
            font-weight: 600;
            color: #374151 !important;
          }
          .yeni-islem-page .yi-card {
            box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
          }
          .yeni-islem-page .yi-single-layout {
            gap: 12px !important;
          }
          .yeni-islem-page .yi-single-left,
          .yeni-islem-page .yi-single-right {
            box-shadow: inset 0 0 0 1px rgba(255,255,255,0.7), 0 2px 6px rgba(15, 23, 42, 0.04);
          }
          .yeni-islem-page .yi-multi-card {
            border-color: #d8e2ee !important;
            background: linear-gradient(180deg, #fcfdff 0%, #f8fbff 100%) !important;
          }
          .yeni-islem-page .yi-multi-item {
            border: 1px solid #e3e9f2 !important;
            border-radius: 10px;
            padding: 10px !important;
            background: #ffffff;
            box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
            margin-bottom: 10px !important;
          }
          .yeni-islem-page .yi-multi-item:last-child {
            margin-bottom: 0 !important;
          }
          .yeni-islem-page .yi-multi-row {
            gap: 10px !important;
            margin-bottom: 10px !important;
          }
          .yeni-islem-page .yi-multi-row > div {
            width: 248px !important;
            min-width: 248px !important;
            max-width: 248px !important;
            flex: 0 0 248px !important;
            box-sizing: border-box;
          }
          .yeni-islem-page .yi-multi-footer {
            border-top: 1px solid #e2e8f0;
            padding-top: 10px;
            margin-top: 12px !important;
          }
          .yeni-islem-page .yeni-islem-form input:not([type="checkbox"]),
          .yeni-islem-page .yeni-islem-form select,
          .yeni-islem-page .yeni-islem-form textarea {
            font-size: 16px !important;
            height: 40px !important;
            border-radius: 5px !important;
            border-color: #d7dde6 !important;
            background-color: #ffffff !important;
            padding-left: 8px !important;
            transition: border-color .2s ease, box-shadow .2s ease;
          }
          .yeni-islem-page .yeni-islem-form input:not([type="checkbox"]):focus,
          .yeni-islem-page .yeni-islem-form select:focus,
          .yeni-islem-page .yeni-islem-form textarea:focus {
            outline: none;
            border-color: #b96a1a !important;
            box-shadow: 0 0 0 3px rgba(185, 106, 26, 0.12);
          }
          .yeni-islem-page .yeni-islem-form textarea {
            min-height: 56px !important;
          }
          .yeni-islem-page .yeni-islem-form p {
            font-size: 15px !important;
          }
          .yeni-islem-page .yeni-islem-form > div:nth-child(4) {
            border: 1px solid #e3e7ef;
            border-radius: 8px;
            background: #fbfcfe;
            padding: 10px;
          }
          .yeni-islem-page .primary-save-button {
            letter-spacing: 0.3px;
          }
          .yeni-islem-page .print-area > div:first-child {
            border-bottom: 1px solid #e8edf4;
          }
          .yeni-islem-page .print-area {
            background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
          }
          .yeni-islem-page .yi-multi-card::-webkit-scrollbar,
          .yeni-islem-page .print-area > div:first-child::-webkit-scrollbar {
            width: 8px;
          }
          .yeni-islem-page .yi-multi-card::-webkit-scrollbar-thumb,
          .yeni-islem-page .print-area > div:first-child::-webkit-scrollbar-thumb {
            background: #c9d4e2;
            border-radius: 20px;
          }
          .yeni-islem-page .yi-multi-card button[type="button"] {
            border-radius: 8px !important;
            font-weight: 700;
          }
          .yeni-islem-page {
            --yi-navy: #0f2744;
            --yi-navy-soft: #16365c;
            --yi-gold: #b78638;
            --yi-gold-soft: #d7b26a;
            --yi-emerald: #0e8f74;
            --yi-royal: #2e5b9a;
            --yi-text: #1f2937;
            --yi-border: #d8e1ec;
            --yi-surface: #ffffff;
            --yi-surface-soft: #f8fbff;
            position: relative;
            overflow: hidden;
            isolation: isolate;
            background: radial-gradient(circle at 8% 10%, rgba(46, 91, 154, 0.14) 0%, transparent 40%),
                        radial-gradient(circle at 92% 82%, rgba(183, 134, 56, 0.16) 0%, transparent 42%),
                        linear-gradient(180deg, #f5f8fd 0%, #edf3fb 100%) !important;
          }
          .yeni-islem-page::before,
          .yeni-islem-page::after {
            content: "";
            position: absolute;
            pointer-events: none;
            z-index: 0;
            filter: blur(2px);
          }
          .yeni-islem-page::before {
            width: 280px;
            height: 280px;
            top: -90px;
            right: -70px;
            border-radius: 999px;
            background: radial-gradient(circle, rgba(183, 134, 56, 0.28) 0%, rgba(183, 134, 56, 0.04) 65%, transparent 100%);
          }
          .yeni-islem-page::after {
            width: 320px;
            height: 320px;
            left: -120px;
            bottom: -120px;
            border-radius: 999px;
            background: radial-gradient(circle, rgba(46, 91, 154, 0.22) 0%, rgba(46, 91, 154, 0.04) 62%, transparent 100%);
          }
          .yeni-islem-page > * {
            position: relative;
            z-index: 1;
          }
          .yeni-islem-page .yeni-islem-form {
            position: relative;
            overflow: hidden;
            backdrop-filter: blur(2px);
          }
          .yeni-islem-page .yeni-islem-form::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 5px;
            background: linear-gradient(90deg, var(--yi-navy) 0%, var(--yi-royal) 35%, var(--yi-gold) 68%, var(--yi-emerald) 100%);
          }
          .yeni-islem-page .yeni-islem-form h2 {
            letter-spacing: 0.25px;
            color: var(--yi-navy) !important;
            text-shadow: 0 1px 0 rgba(255,255,255,0.8);
          }
          .yeni-islem-page .yeni-islem-form > div:nth-child(2) {
            box-shadow: inset 0 0 0 1px rgba(215, 178, 106, 0.36), 0 2px 8px rgba(183, 134, 56, 0.08);
            background: linear-gradient(135deg, #fff8ea 0%, #f6ecd8 100%) !important;
          }
          .yeni-islem-page .yi-card {
            border-color: var(--yi-border) !important;
            background: linear-gradient(180deg, #ffffff 0%, #f8fbff 72%, #f4f8ff 100%) !important;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.8), 0 4px 14px rgba(15, 39, 68, 0.06);
          }
          .yeni-islem-page .yeni-islem-form input::placeholder,
          .yeni-islem-page .yeni-islem-form textarea::placeholder {
            color: #8d98ab;
            font-weight: 500;
          }
          .yeni-islem-page .yeni-islem-form select {
            font-weight: 600;
          }
          .yeni-islem-page .primary-save-button {
            background: linear-gradient(135deg, #cf9437 0%, #b67924 46%, #9b6118 100%) !important;
            border: 1px solid #9f5e15 !important;
            min-height: 44px;
            text-transform: uppercase;
            letter-spacing: 0.6px;
            box-shadow: 0 6px 14px rgba(162, 98, 23, 0.32), inset 0 1px 0 rgba(255,255,255,0.2) !important;
          }
          .yeni-islem-page .primary-save-button:hover {
            filter: brightness(1.03);
            transform: translateY(-1px);
            box-shadow: 0 10px 18px rgba(165, 102, 27, 0.25);
          }
          .yeni-islem-page .print-area {
            border: 1px solid #d2dcea !important;
            background: linear-gradient(180deg, #f8fbff 0%, #eef3fb 60%, #e8eef8 100%) !important;
            box-shadow: 0 10px 24px rgba(14, 29, 53, 0.14), inset 0 1px 0 rgba(255,255,255,0.75) !important;
          }
          .yeni-islem-page .print-area > div:first-child {
            border-radius: 10px 10px 0 0;
            background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
          }
          .yeni-islem-page .print-area > button {
            background: linear-gradient(135deg, #1c4372 0%, #102742 58%, #0a1a2f 100%) !important;
            border: 1px solid #0c223d;
            min-height: 42px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            box-shadow: 0 6px 14px rgba(11, 28, 50, 0.30), inset 0 1px 0 rgba(255,255,255,0.16);
          }
          .yeni-islem-page .print-area > button:hover {
            filter: brightness(1.05);
            transform: translateY(-1px);
          }

          /* --- MOBİL: Yeni İşlem tekli düzen --- */
          /* Kompakt duzen: telefonlar + dokunmatik tabletler.
             Tablette de form/fis tek sutuna iner, .yi-field etiketi kutunun ustune
             alir ve .yi-control'un satir ici maxWidth:45% kisitini kaldirir. */
          @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
            /* Dokun-çek kaydırma "takılma" azaltma: checkbox ve butonlarda tık gecikmesini düşür */
            .yeni-islem-page .yi-multi-toggle {
              -webkit-tap-highlight-color: transparent;
              touch-action: manipulation;
            }

            .yeni-islem-page .primary-save-button {
              -webkit-tap-highlight-color: transparent;
              touch-action: manipulation;
            }

            .yeni-islem-page {
              flex-direction: column !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              overflow-x: hidden !important;
              -webkit-overflow-scrolling: touch;
              overscroll-behavior-x: none;
              padding: 0 !important;
              gap: 10px !important;
              width: 100% !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
            }

            /* Dekoratif blur daireleri mobilde taşma/zıplama yapmasın */
            .yeni-islem-page::before,
            .yeni-islem-page::after {
              display: none !important;
            }

            .yeni-islem-page .yeni-islem-form {
              flex: none !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
              overflow: hidden !important;
              flex-shrink: 0 !important;
              padding: 12px 10px 14px !important;
              box-sizing: border-box !important;
              order: 1;
            }

            .yeni-islem-page .yeni-islem-form::before {
              left: 0 !important;
              right: 0 !important;
              width: auto !important;
            }

            .yeni-islem-page .yi-top-row,
            .yeni-islem-page .yi-card,
            .yeni-islem-page .yi-customer-row,
            .yeni-islem-page .yi-type-row {
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
              box-sizing: border-box !important;
            }

            .yeni-islem-page .yi-card {
              padding: 8px !important;
            }

            .yeni-islem-page .yi-multi-toggle {
              padding: 8px 10px !important;
            }

            .yeni-islem-page .yeni-islem-form > div:first-child {
              padding-top: 2px !important;
              margin-bottom: 4px !important;
            }

            .yeni-islem-page .yeni-islem-form h2 {
              font-size: 20px !important;
              line-height: 1.25 !important;
            }

            .yeni-islem-page .yeni-islem-form > p,
            .yeni-islem-page .yeni-islem-form > div:first-child p {
              font-size: 13px !important;
              line-height: 1.45 !important;
            }

            .yeni-islem-page .yi-single-layout {
              flex-direction: column !important;
            }

            .yeni-islem-page .yi-single-left,
            .yeni-islem-page .yi-single-right {
              height: auto !important;
            }

            .yeni-islem-page .yi-mobile-row {
              display: grid !important;
              gap: 10px !important;
              align-items: start !important;
              margin-bottom: 8px !important;
            }

            .yeni-islem-page .yi-mobile-row-1 {
              grid-template-columns: 1fr !important;
            }

            .yeni-islem-page .yi-mobile-row-2 {
              grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            }

            .yeni-islem-page .yi-mobile-row-3 {
              grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
            }

            .yeni-islem-page .yi-field {
              display: flex !important;
              flex-direction: column !important;
              align-items: stretch !important;
              gap: 6px !important;
              min-width: 0 !important;
            }

            .yeni-islem-page .yi-field label {
              width: auto !important;
              font-size: 14px !important;
              color: rgba(55, 65, 81, 0.92) !important;
            }

            .yeni-islem-page .yi-control {
              max-width: none !important;
              width: 100% !important;
            }

            .yeni-islem-page .yi-control input,
            .yeni-islem-page .yi-control textarea {
              width: 100% !important;
            }

            .yeni-islem-page .yi-single-right input,
            .yeni-islem-page .yi-single-right textarea {
              width: 100% !important;
              max-width: none !important;
            }

            /* Çoklu modda sabit 248px genişlikleri mobilde iptal et */
            .yeni-islem-page .yi-multi-row {
              flex-direction: column !important;
              align-items: stretch !important;
            }

            .yeni-islem-page .yi-multi-row > div {
              width: 100% !important;
              min-width: 0 !important;
              max-width: none !important;
              flex: 1 1 auto !important;
            }

            .yeni-islem-page .yi-multi-footer {
              display: flex !important;
              flex-direction: column !important;
              align-items: stretch !important;
              gap: 8px !important;
            }

            .yeni-islem-page .yi-multi-footer p {
              width: auto !important;
              max-width: min(340px, 86vw) !important;
              align-self: center !important;
              border-radius: 12px !important;
              margin: 0 !important;
              text-align: left !important;
            }

            .yeni-islem-page .print-area {
              flex: none !important;
              flex-shrink: 0 !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              max-height: none !important;
              overflow: visible !important;
              order: 2;
            }

            .yeni-islem-page .print-area > div:first-child {
              height: auto !important;
              max-height: min(440px, 52vh) !important;
              min-height: 180px !important;
              overflow-y: auto !important;
              -webkit-overflow-scrolling: touch;
            }

            .yeni-islem-page .print-area > button {
              touch-action: manipulation;
              -webkit-tap-highlight-color: transparent;
            }

            .yeni-islem-page .primary-save-button {
              width: min(280px, 78vw) !important;
              margin-left: auto !important;
              margin-right: auto !important;
            }
          }

          /* Telefonda dugmeler gereksiz genisliyordu */
          @media (max-width: 560px) {
            .yeni-islem-page .primary-save-button {
              width: min(210px, 58vw) !important;
            }

            .yeni-islem-page .print-area > button {
              width: auto !important;
              min-width: 150px !important;
              align-self: center !important;
            }
          }

          /* --- MASAÜSTÜ: Mobil satır wrapper'ları akışı bozmasın --- */
          /* Genis + FARE duzeni. "any-pointer: fine" eklendi: aksi halde bu blok
             dokunmatik tablette de calisip yukaridaki kompakt kurallari (ozellikle
             .yi-mobile-row) ezerdi. Masaustu her zaman "fine" bildirir, degismez. */
          /* 1650px alti: dar masaustu penceresi de kompakt duzeni kullanir,
             bu blok oraya karismasin (eskiden 481px+ her fare ekranini kapsiyordu). */
          @media (min-width: 1650px) and (any-pointer: fine) {
            .yeni-islem-page .yi-single-left,
            .yeni-islem-page .yi-single-right {
              gap: 10px !important;
            }

            .yeni-islem-page .yi-mobile-row {
              display: contents;
            }

            .yeni-islem-page .yi-delivery-box {
              padding: 10px 12px !important;
              border-radius: 10px !important;
              border: 1px solid rgba(220, 38, 38, 0.18);
              background: linear-gradient(180deg, #fff1f2 0%, #ffe4e6 100%) !important;
            }

            .yeni-islem-page .yi-delivery-row label {
              font-size: 16px !important;
            }

            .yeni-islem-page .yi-delivery-row input[type="checkbox"] {
              width: 18px !important;
              height: 18px !important;
            }

            .yeni-islem-page .yi-delivery-date-row {
              gap: 10px !important;
            }

            .yeni-islem-page .yi-delivery-date-row label {
              font-size: 14px !important;
              color: rgba(55, 65, 81, 0.9) !important;
            }

            .yeni-islem-page .yi-delivery-date-row input[type="date"] {
              height: 34px !important;
              padding: 0 10px !important;
              border-radius: 8px !important;
              border-color: rgba(15, 39, 68, 0.18) !important;
            }
          }
          .yeni-islem-page .yi-multi-item {
            border-left: 4px solid #c9d9ec !important;
            background: linear-gradient(180deg, #ffffff 0%, #f9fbff 100%) !important;
          }
          .yeni-islem-page .yi-multi-item:focus-within {
            border-left-color: var(--yi-gold) !important;
            box-shadow: 0 6px 16px rgba(15, 39, 68, 0.08), 0 0 0 1px rgba(183, 134, 56, 0.15);
          }
          .yeni-islem-page .yi-multi-footer p {
            background: #f3f7fd;
            border: 1px solid #d9e3f0;
            border-radius: 999px;
            padding: 6px 12px;
          }
          .yeni-islem-page .yi-multi-footer p:last-child {
            background: linear-gradient(180deg, #f7efe0 0%, #f2e3c2 100%);
            border-color: #e0c78f;
            color: #5f430f !important;
          }
          .yeni-islem-page .yeni-islem-form select {
            background-image: linear-gradient(45deg, transparent 50%, #a67a35 50%), linear-gradient(135deg, #a67a35 50%, transparent 50%);
            background-position: calc(100% - 16px) calc(50% - 3px), calc(100% - 11px) calc(50% - 3px);
            background-size: 5px 5px, 5px 5px;
            background-repeat: no-repeat;
            padding-right: 28px !important;
          }
          .yeni-islem-page .yi-multi-card button[type="button"][style*="backgroundColor: '#10b981'"] {
            background: linear-gradient(135deg, #1db98d 0%, #0f8b6a 100%) !important;
            box-shadow: 0 4px 10px rgba(14, 143, 116, 0.25);
          }
          .yeni-islem-page .yi-multi-card button[type="button"][style*="backgroundColor: '#dc2626'"] {
            background: linear-gradient(135deg, #e54a4a 0%, #be2727 100%) !important;
            box-shadow: 0 4px 10px rgba(190, 39, 39, 0.26);
          }
          select, input, textarea {
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            line-height: normal;
            margin: 0;
          }
          input[type="checkbox"] {
            -webkit-appearance: checkbox;
            -moz-appearance: checkbox;
            appearance: checkbox;
            width: 20px;
            height: 20px;
            display: inline-block;
            visibility: visible;
            margin: 0;
            cursor: pointer;
          }
          select {
            background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="5" viewBox="0 0 10 5"><path d="M0 0h10L5 5z" fill="%23000"/></svg>') no-repeat right 8px center;
            background-size: 10px 5px;
          }
          @media print {
            body * {
              visibility: hidden;
            }
            .print-area, .print-area * {
              visibility: visible;
            }
            /* En dıştaki büyük kutu: ekranı kaplayan .print-area — yazdırmada kaldır (inline stilleri de ez) */
            .print-area {
              position: fixed !important;
              inset: auto !important;
              left: 50% !important;
              top: 50% !important;
              transform: translate(-50%, -50%) !important;
              width: fit-content !important;
              max-width: 100% !important;
              height: fit-content !important;
              max-height: none !important;
              flex: none !important;
              margin: 0 !important;
              padding: 0 !important;
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              justify-content: center !important;
              gap: 0 !important;
              background: transparent !important;
              box-shadow: none !important;
              border: none !important;
              overflow: visible !important;
              box-sizing: border-box !important;
            }
            /* Fiş + yazdır butonu alanı: sadece bu kart görünsün */
            .print-area > div:first-child {
              width: fit-content !important;
              max-width: 92vw !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
              margin: 0 !important;
              padding: 10px 12px !important;
              border-radius: 12px !important;
              border: 1px solid rgba(15, 39, 68, 0.12) !important;
              background: #fff !important;
              box-shadow: 0 8px 22px rgba(15, 39, 68, 0.1) !important;
              box-sizing: border-box !important;
            }
            .print-area .yi-receipt {
              width: 280px !important;
              max-width: 72vw !important;
              padding: 12px 14px !important;
            }
            .print-area button {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
}

export default YeniIslem;